/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="inventoryCount.module.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />
/// <reference path="../../components/common/inventory.common.context.ts" />
/// <reference path="../../components/controls/barcodeScanner/barcodeScanner.ts" />
/// <reference path="../../components/modal/modal.enums.ts" />

module Meevo.Plugins.InventoryCount {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import InventoryCountStateEnum = Meevo.Model.InventoryCountStateEnum;
    import LineItems = Meevo.Model.InventoryCountLineItems;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import BarcodeScanModes = Meevo.Components.Controls.BarcodeScanModes;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;
    const autoSaveDelay : number = 1000;
    const autoSaveKeyPrimary : string = "variantId"
    const autoSaveKeySecondary: string = "productInventoryType";
    enum QuantityViewType {
        Decimal = 0,
        Units = 1
    }
    
    export class InventoryCountContext extends Meevo.Components.Common.InventoryCommonContext {
        backupInventoryCount: Meevo.Model.InventoryCount;
        itemsArrayCtrl: any;
        // selectAllBox: boolean;
        isHideOnHand: boolean;
        isInventoryFloorLocationModuleAvailable: boolean;
        mode: Meevo.Model.MaintenanceFormState; // This controls the UI behavior for the Desktop
        INVENTORY_COUNT_WRITE: string;
        INVENTORY_COUNT_DELETE: string;
        INVENTORY_COUNT_READ: string;
        INVENTORY_COUNT_CREATE: string;
        INVENTORY_COUNT_COMMIT: string;
        INVENTORY_COUNT_LINEITEM_DELETE: string;
        DATA_PRODUCT_TAB_MAIN: string;

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected products: any;
        protected selectedFloorLocation: any;          // { id, displayName } bound to the floor-location typeahead's ng-model
        protected floorLocationCriteria: any;          // server-side filter passed via the typeahead's `criteria` binding
        protected manufacturer: any;
        protected productVariantFilter: string;
        protected includeDiscontinued: boolean;
        protected productVariantInventoryType: ProductInventoryTypeEnum;
        protected productTypes: any;
        public inventoryCount: Meevo.Model.InventoryCount = null;
        protected inventoryCounts: any;
        protected lineItem: LineItems;
        protected floorLocationId: Guid;
        protected lineItemsStatus: any;
        public product: any = {};
        protected controller: any;
        protected confirmationMessage: string;
        public originalActualCount: number;
        protected openInventoryCountStateEnum = InventoryCountStateEnum.Open;
        protected searchCriteria: any;
        protected productSearchCriteria: any;
        protected productLookupCriteria: Model.IInventoryCountProductSearchCriteria;
        protected trueValue: boolean;
        protected $q: ng.IQService;
        protected $timeout: ng.ITimeoutService;
        protected resolvedPromise = true;
        protected isCountStarted = false;
        protected isConflict = false;
        protected customColumns: any;
        protected dateCreatedColumn: any;
        protected recentlyChangedVariableAttribute = "recentlyChanged";
        protected recentlyChangedNumber = 0;
        public isNewCount: boolean = false;
        inAutoSaveProcess: boolean = false;
        inSaveProcess: boolean = false;
        protected countStateExclusionList: InventoryCountStateEnum[];
        public orderItemsByList: any[];
        protected inventoryCountOrder: string = "ManufacturerName";
        private secondaryCountOrder: string = "VariantSku";
        protected inventoryCountSortOption: any = { fieldName: this.inventoryCountOrder, sortDirection: Model.SortDirection.Ascending };
        public isDirty: boolean = false;
        searchScreen: boolean = false;
        baseEndPoint: string;
        allDistributor: boolean;
        allManufacturer: boolean;
        allProductCategory: boolean;
        chkShowNotCountedSince: boolean;
        protected isFilterByComplete: boolean;
        private itemsPerPage: number = 200;
        protected virtualMaximum: number = this.itemsPerPage;
        public distributorMoverModel: any;
        public manufacturerMoverModel: any;
        public productCategoryMoverModel: any;
        private meevoCurrency: any;
        public isAutoSaveEnabled: boolean = true;
        public showAutoSaveSuccessful: boolean = false;
        private autoSaveTimers: any = {};
        private holdLineItems: Record<string, LineItems[]> = {};
        public barcodeScanner: any;
        public searchExpanded: boolean = false;
        public addExpanded: boolean = false;
        public typeaheadCount: number = 0;
        public isPrinting: boolean = false;

        public productSplitFields : any;
        private foundBarcodes: any = [];
        private barcodeScanMode: BarcodeScanModes;

        public successSound : HTMLAudioElement = new Audio("/assets/audio/ding.mp3")
        public failSound : HTMLAudioElement = new Audio("/assets/audio/fail.mp3")
        public highlightId: string;
        public productLookup : any;
        public currentInventoryType : ProductInventoryTypeEnum = null; // applies to next barcode scan when counting retail/shopsupply
        public swiperInstances: any;
        private needsReconciliation: boolean = false;
        private uniqueCodes: any;
        public todayDate : Date = new Date();

        public barcodeScanResults: any = {
            0: [ ], // not found
            1: new Map()// matches
        };
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;
        public isProductLotModuleEnabled: boolean = false;
        public switchButtons: Meevo.Components.Controls.ISwitchButton[] = [
            { displayName: 'Decimal', key: QuantityViewType.Decimal },
            { displayName: 'Units', key: QuantityViewType.Units },
        ];
        public QuantityViewType = QuantityViewType;
        public viewQuantity: QuantityViewType = QuantityViewType.Decimal;

        get floorLocationKey() : string {
            return this.productSearchCriteria && this.productSearchCriteria.floorLocationId ? this.productSearchCriteria.floorLocationId.toString() : '0';
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
            protected inventoryController: any,
            protected securityChecker: Meevo.Components.Common.SecurityService,
            protected q: ng.IQService,
            protected timeout: ng.ITimeoutService,
            protected meevoDateFilter: any,
            protected $state: any,
            protected $filter: angular.IFilterService,
            protected $rootScope: angular.IRootScopeService,
            private $mdSidenav: any,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            public $translate: ng.translate.ITranslateService,
            // Lot-tracking modal bridge — opens <meevo-lot-tracking-modal> with
            // inventory-count context. Wired from the controller's $inject list
            // (Step 12.3 / FA4 11.3). Plugin-specific wrapper around the shared
            // Meevo.Components.Common.LotModalBridgeHelper.
            private lotBridge?: Meevo.Plugins.InventoryCount.LotModalBridge) {

            super(appSettings, $rootScope);

            this.INVENTORY_COUNT_READ = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_READ;
            this.INVENTORY_COUNT_WRITE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_WRITE;
            this.INVENTORY_COUNT_DELETE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_DELETE;
            this.INVENTORY_COUNT_CREATE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_CREATE;
            this.INVENTORY_COUNT_COMMIT = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_COMMIT;
            this.INVENTORY_COUNT_LINEITEM_DELETE = this.securityKeys.INVENTORY_COUNT_LINEITEM + this.securityParts.KEY_PART_DELETE;
            this.DATA_PRODUCT_TAB_MAIN = this.securityKeys.DATA_PRODUCT_TAB_MAIN + this.securityParts.KEY_PART_READ;
            this.baseEndPoint = `${this.appSettings.API_ROOT}/InventoryCount`;

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.controller = inventoryController;
            this.$q = q;
            this.$timeout = timeout;

            this.initializePage();
            console.log('inventory count constructor')

        }

        initializePage(): void {
            // 130417: gate the lot-scan tip on the location having the Product Lot &
            // Expiration Tracking module enabled. Passed into the barcode scanner via
            // IBarcodeScannerOptions (desktop modal) and the mobile inline scanner.
            this.securityChecker.checkModuleAccess(this.securityKeys.DATA_PRODUCTLOTEXPIRATIONTRACKINGMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then(access => {
                    this.isProductLotModuleEnabled = access === Meevo.Model.SecurityAccessEnum.Grant;
                });

            this.generateProductSplitFields();
            this.attachPrintListener();
            this.floorLocationCriteria = {
                includeActive: true,
                includeInactive: false,
                includeDeleted: false
            };
            this.searchForInventoryCounts(InventoryCountStateEnum.Open);
            this.resetInventoryCount();
            this.virtualMaximum = 0;
            this.floorLocationId = null;
            this.trueValue = true;
            this.searchScreen = true;
            this.allDistributor = true;
            this.allManufacturer= true;
            this.allProductCategory = true;
            this.chkShowNotCountedSince = false;

            this.productVariantFilter = "";
            this.inventoryCounts = [];
            this.countStateExclusionList=[InventoryCountStateEnum.Reviewing];

            this.lineItemsStatus = [];
            this.lineItemsStatus.push({ "key": null, "value": "LABEL_ALL_ITEM" });
            this.lineItemsStatus.push({ "key": true, "value": "LABEL_COUNTED_ITEM" });
            this.lineItemsStatus.push({ "key": false, "value": "LABEL_NOT_COUNTED_ITEM" });

            this.createOrderByList();            

            this.searchCriteria = {
                "state": InventoryCountStateEnum.Open,
                "productObjectState": Meevo.Model.ObjectStateEnum.Active,
                "variantObjectState": Meevo.Model.ObjectStateEnum.Active,
                "isInventoryTrackable": true,
                "iscounted": null
            };

            this.productSearchCriteria = {
                "productObjectState": Meevo.Model.ObjectStateEnum.Active,
                "variantObjectState": [Meevo.Model.ObjectStateEnum.Active],
                "productInventoryType": ProductInventoryTypeEnum.Retail,
                "isInventoryTrackable": true,
                "floorLocationId": null,
                "id": this.inventoryCount.id,
                "inventoryCountOnly": false,
                "iscounted": null,
                "filter": null,
                "manufacturerIds": [],
                "distributorIds": [],
                "productCatIds": [],
            };

            this.generateProductLookupCriteria();

            this.dateCreatedColumn = { header: "Date Created", fieldName: 'DateCreated', sortDirection: null, width: 20 };

            this.customColumns = [
                { header: "Display Name", fieldName: 'DisplayName', sortDirection: null, width: 45 },
                { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 30 },
                { header: "Products", fieldName: 'Products', sortDirection: null, width: 25 }
            ];

            this.securityChecker.checkSecurityKey(this.securityKeys.INVENTORY_COUNT_FIELD_ONHAND + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.isHideOnHand = securityCode !== SecurityAccessEnum.Grant;
                });
            this.securityChecker.checkSecurityKey(this.securityKeys.INVENTORY_FLOORLOCATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.isInventoryFloorLocationModuleAvailable = securityCode === SecurityAccessEnum.Grant;
                });

            this.meevoCurrency = this.$filter("meevoCurrency") as any;
            this.currentInventoryType = null;
        }

        generateProductLookupCriteria(): any {
            this.productLookupCriteria = {
                productObjectState: Meevo.Model.ObjectStateEnum.Active,
                variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                isInventoryTrackable: true,
                productInventoryType: this.productSearchCriteria.productInventoryType,
                floorLocationId: this.productSearchCriteria.floorLocationId,
                id: this.inventoryCount.id,
                distributorIds: this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection,
                manufacturerIds: this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection,
                productCatIds: this.productCategoryMoverModel.isAllSelected? [] : this.productCategoryMoverModel.collection,
                inventoryCountOnly: false
            };
        }

        fixScrolling() : void {
            var timer = setInterval(() => {
                var scroller = document.querySelector('.inventory-count-virtual-repeater .md-virtual-repeat-scroller');
                if (scroller) {
                    scroller.addEventListener('scroll', (e: any) => {
                        this.controller.$scope.$apply();                        
                    });
                    clearInterval(timer);                    
                } else {
                    console.log('virtual repeater not ready')
                }

                var scroller2 = document.querySelector('.inventory-table-container.meevo-scrollbar');
                if (scroller2) {
                    scroller2.addEventListener('scroll', this.scrollHeader);
                    clearInterval(timer);
                } else {
                    console.log('virtual repeater not ready')
                }
            }, 300);
            
        }

        createOrderByList() : void {
            this.orderItemsByList = [];
            this.orderItemsByList.push({ "key": "VariantBarCode", "value": "LABEL_BARCODE" });
            this.orderItemsByList.push({ "key": "DisplayName", "value": "LABEL_DISPLAY_NAME" });
            this.orderItemsByList.push({ "key": "ManufacturerName", "value": "LABEL_MANUFACTURER" });
            if (this.isMiscSupplyCount()) {
                this.orderItemsByList.push({ "key": "SupplyCategory", "value": "LABEL_SUPPLY_CATEGORY" });
            } else {
                this.orderItemsByList.push({ "key": "ProductCategory,ProductSubCategory", "value": "LABEL_INPUT_PRODUCT_CATEGORY" });
            }
            this.orderItemsByList.push({ "key": "VariantSku", "value": "LABEL_SKU_CODE" });
        }

        inventoryTypeChange() : void {
            this.createOrderByList();
            this.generateProductLookupCriteria();
            if (!this.isMiscSupplyCount() && this.inventoryCountSortOption.fieldName == 'SupplyCategory') {
                this.inventoryCountSortOption.fieldName = "ProductCategory";
            } else if (this.isMiscSupplyCount() && this.inventoryCountSortOption.fieldName == 'ProductCategory') {
                this.inventoryCountSortOption.fieldName = "SupplyCategory";
            }
            if (this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                this.search();
            }            
        }

        generateProductSplitFields() : void {
            this.productSplitFields = 
            [
                { 
                    'label': 'LABEL_SKU_CODE',
                    'key': 'sku',
                    'className': 'line-item-link',
                    'sortOrder': ['VariantBarCode', 'DisplayName'].some(x => x == this.inventoryCountOrder) ? 2 : 1
                },
                { 
                    'label': 'LABEL_DISPLAY_NAME',
                    'key': 'displayName',
                    'className': 'line-item-link',
                    'sortOrder': this.inventoryCountOrder == 'DisplayName' ? 1 : this.inventoryCountOrder == 'VariantBarCode' ? 3 : 2
                },
                { 
                    'label': 'LABEL_BARCODE',
                    'key': 'barCode',
                    'className': 'line-item-link',
                    'sortOrder': this.inventoryCountOrder == 'DisplayName' ? 3 : this.inventoryCountOrder == 'VariantBarCode' ? 1 : 3
                }
            ]
        }

        getSplitFieldItem(ndx) : any {
            return this.productSplitFields.find(x => x.sortOrder == ndx) || {};
        }

        getSplitFieldHeader(ndx) : string {
            let item = this.getSplitFieldItem(ndx);
            return item ? this.$translate.instant(item.label) : '';
        }

        getSplitFieldValue(ndx, product) : string {
            let item = this.getSplitFieldItem(ndx);
            return this.getProductSplitFieldValue(product, item.key);
        }

        getSplitFieldId(ndx, product) : string {
            return `${product['entityVersion']}${ndx}`;
        }

        getSplitFieldClass(ndx) : string {
            return this.getSplitFieldItem(ndx).className;
        }
        

        showDataToolTip(item) : boolean {
            if (!item) return false;
            var el = $(`#${item}`)[0];
            if (!el) return false;
            return el.scrollHeight > el.clientHeight + 2;
        }
        
        getProductSplitFieldValue(product, key) : string {
            return key == 'displayName'
                ? this.getLineItemDisplayName(product)
                : product[key] ||  ' ';
        }
        
        getProductTypeaheadHeight() {
            return  { 'min-height': `${($("#mobile-count #product-lookup-input .meevo-typeahead-listContainer").height() || 0) + 60}px` };
        }

        removeAllChildNodes(parent) {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        }

        getLineItemDisplayName(item) : string {
            return item.productName ? (item.displayName ? `${item.productName} - ${item.displayName}` : item.productName) : item.displayName;
        }
        
        public scannerOpened : string = '';
        // WI 130400: re-entrancy guard for the Assign Scanned Lots modal. In
        // Camera/File mode the scanner modal stays open behind the lot modal
        // (keepScannerOpen), so another scan (e.g. a camera auto-detect) could call
        // openScannedLotModal again and mount a SECOND batch modal on top — each
        // emitting savedBatch independently. True while a lot modal is open/pending;
        // cleared when it saves or cancels.
        public lotModalPending : boolean = false;
        openBarcodeScanner(val: string) : void {
            if (!val) return;

            // Clears the resolved per-scan type (read at lines ~955/1015/1031/1056-1058)
            // so a fresh scanner session doesn't inherit the previous session's resolved type.
            // Does not affect the modal's initial options below - those seed from
            // inventoryCount/productSearchCriteria via ensureInventoryTypeSeeded().
            this.currentInventoryType = null;
            this.scannerOpened = val;
            if (this.scannerOpened !== 'mobile') {
                this.openBarcodeScannerModal();
            }
            this.mode = MaintenanceFormState.Editing;
        }

        // Backfills the count's header-level productInventoryType from the search
        // criteria the first time a new, unsaved count needs one (barcode scan or
        // manual search), so downstream consumers (e.g. the scanner modal) always
        // see a resolved type instead of null.
        ensureInventoryTypeSeeded(): void {
            if (this.inventoryCount && !this.inventoryCount.id && !this.inventoryCount.productInventoryType && this.productSearchCriteria.productInventoryType) {
                this.inventoryCount.productInventoryType = this.productSearchCriteria.productInventoryType;
            }
        }

        openBarcodeScannerModal(): void {
            this.ensureInventoryTypeSeeded();

            let useProductInventoryType = (this.inventoryCount && this.inventoryCount.productInventoryType) ? this.inventoryCount.productInventoryType : this.productSearchCriteria.productInventoryType;
            let options : Meevo.Plugins.Product.IBarcodeScannerOptions = {
                productInventoryTypeEnum: useProductInventoryType,
                savedInventoryTypeEnum: useProductInventoryType,
                productLotModuleEnabled: this.isProductLotModuleEnabled
            };

            let callbacks : Meevo.Plugins.Product.IBarCodeScannerCallbacks = {
                onScan: this.barcodeSearch.bind(this),
                onDestroy: this.barcodeScannerDestroyed.bind(this),
                onInventoryTypeChange: this.currentInventoryTypeChange.bind(this),
                onBarcodeScanModeChange: this.barcodeScanModeChange.bind(this)
            };

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/controls/barcodeScanner/barcodeScannerModal.template.html",
                controller: "meevo.components.controls.BarcodeScannerModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: options,
                    callbacks: callbacks
                }
            }
            this.modalService.showCustom(modalOptions);
        }

        barcodeScannerDestroyed(isModal) : void {
            console.log('barcodeScannerDestroyed', this)
            if (isModal) {
                this.closeCustomModal();
            } else {
                this.closeBarcodeScanner();
            }
        }

        currentInventoryTypeChange(data: ProductInventoryTypeEnum) : void {
            console.log('currentInventoryTypeChange', data)
            var vm = this;
            setTimeout(() => {
                vm.currentInventoryType = data;    
            });            
        }

        barcodeScanModeChange(scanMode: BarcodeScanModes) : void {
            console.log('barcodeScanModeChange', scanMode)
            this.barcodeScanMode = scanMode;
        }

        doBarcodeScannerOpen() : void {
            if (this.scannerOpened !== 'mobile') {
                this.openBarcodeScannerModal();
            }
        }

        openProductInventoryTypeModal(productVariant, labelText, noteText, listOfTypes) : ng.IPromise<any> {
            let modalOptions : Meevo.Plugins.Product.ProductInventoryTypeModalOptions = {
                product: productVariant,
                labelText: labelText,
                noteText: noteText,
                listOfTypes: listOfTypes
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/inventoryCount/dialogs/productInventoryTypeModal.template.html",
                controller: "meevo.plugins.inventoryCount.ProductInventoryTypeModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: modalOptions
                }
            }
            return this.modalService.showCustom(options);
        }

        openBarcodeImportReconcilerModal(productVariants: any) : ng.IPromise<any> {
            let modalOptions : Meevo.Plugins.Product.BarcodeImportReconcilerModalOptions = {
                variants: productVariants,
                uniqueCodes: this.uniqueCodes
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/inventoryCount/dialogs/barcodeImportReconciler.template.html",
                controller: "meevo.plugins.inventoryCount.BarcodeImportReconcilerModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: modalOptions
                }
            }
            return this.modalService.showCustom(options);
        }

        lineItemSwipe(swiper, item) : void {
            console.log('lineItemSwipe', swiper, item)
            var variantId = swiper.container[0].dataset.variantid;
            var productInventoryType = swiper.container[0].dataset.productinventorytype;
            var ndx =  this.inventoryCount.lineItems.findIndex(x => x.variantId == variantId && x.productInventoryType == productInventoryType);
            if (ndx > -1) {
                this.removeLineItem(item);
            }
        }

        
        
        barcodeScanned = (codes) : void => {
            
            setTimeout(() => {
                if (!codes || codes.length < 1) return;
                this.controller.viewSwitch('count');
    
                this.foundBarcodes = codes.filter(x => {
                    return !this.barcodeScanResults[0].some(y => y == x);
                });
    
                if (this.foundBarcodes.length == 0) {
                    this.createBarcodeFailureToast(codes.join(','));
                } else {
                    this.runBarcodeLookup(this.foundBarcodes);
                }
            });
        }

        processSuccessfulBarcodeScan(product) : void {
            this.successSound.play();
            this.recordBarcodeScan(product);
            this.productVariantFilter = "";
        }

        processUnsuccessfulBarcodeScan(codes): void {
            this.createBarcodeFailureToast(codes.join(", "));
            this.recordBarcodeScanMismatch(codes);
        }

        runBarcodeLookup(codes) : void {
            this.barcodeSearch(codes, true).then((res : any) => {
                if (res) {
                    this.processSuccessfulBarcodeScan(Symbol.iterator in Object(res) ? res[0] : res)
                } else if (res === false) {
                    this.processUnsuccessfulBarcodeScan(codes);
                }
                console.log('barcode searched', res);
            }).catch((err) => {
                this.processUnsuccessfulBarcodeScan(codes);
            })
        }

        recordBarcodeScan(product) : void {
            this.barcodeScanResults[1].set(product.barCode, product);
        }

        recordBarcodeScanMismatch(codes) : void {
            for (let i = 0; i < codes.length; i++) {
                this.barcodeScanResults[0].push(codes[i]);
            }
        }

        highlightAddedItem(item) {
            this.$timeout(() => {
                this.ScrollToProduct(item.variantId, item.productInventoryType);
                this.productLookup = null;
            }, 500);
        }

        isMobileUi() : boolean {
            return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 960;
        }

        ScrollToProduct(id, productInventoryType) : void {
            
            let thisParent, heightOfItem : number;
            if (this.isMobileUi()) {
                thisParent = document.getElementById("mobile-count");    
                heightOfItem = 100;
            } else {
                thisParent = document.getElementById("desktop_count");
                heightOfItem = 56;
            }

            // find the index of the very first matching variant
            let ndx = _.findIndex(this.inventoryCount.lineItems, (item) => { return item.variantId == id && item.productInventoryType == productInventoryType });
            if (thisParent != null && ndx >= 0) {
                // scroll to top of first item matched
                let el = thisParent.getElementsByClassName("md-virtual-repeat-scroller")[0];
                let newScrollTop: number = ndx <= 0 ? 0 : (ndx * heightOfItem);
                newScrollTop = newScrollTop > (el.scrollHeight - el.clientHeight) ? (el.scrollHeight - el.clientHeight) : newScrollTop;
                el.scroll({left: 0, top: newScrollTop, behavior: 'smooth'});

                let highlightInterval = setInterval(() => {
                    var item = $(el).find('#virtual_productId_' + this.getConcatenatedString(id, productInventoryType))[0];
                    if (item) {
                        item.classList.add('item-highlight');
                        setTimeout(() => {
                            item.classList.remove('item-highlight');
                        }, 2000);
                        clearInterval(highlightInterval);
                    }    
                }, 100);

            }
        }

        getConcatenatedString(id, type): string {
            return id + '_' + type;
        }

        createBarcodeFailureToast(code : string) : void {
            var toast = this.controller.$mdToast.simple();
            toast.textContent(`Barcode (${code}) not found.`);
            toast.position("bottom right");
            toast.parent(angular.element("div#barcode-scanner"));
            toast.hideDelay(5000);
            toast.action("X"); // Will close the toast when clicked.
            this.controller.$mdToast.show(toast);
            this.failSound.play();
        }

        openProductDefinition(item: any) {
            item.productId = item.product_TId;
            super.openProductDefinition(item);
        }

        isSecurityDenyOrGrant(key): boolean {
            return this.securityChecker.hasSecurityDenyOrGrant(key);
        }

        replaceBarSymbol(attribute): string{
            if (attribute == null || attribute == undefined || attribute == '')
                return '';
            else
                return " - "+attribute.split(/[|]/g).join(' ');
        }

        showInformation(prod: any) {
            let modalOptions : Meevo.Plugins.Product.ProductInfoModalOptions = {
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryCount,
                productId: prod.product_TId,
                variantId: prod.variantId,
                productInventoryTypeEnum: prod.productInventoryType,
                isInventoryFloorLocationModuleAvailable: this.isInventoryFloorLocationModuleAvailable
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

        showItemConflictInfo(item) {
            return this.showVariantTransaction(item.variantId, item.productInventoryType, item.startOnHandDateTime, item.sku, item.productName, item.displayName, item.barCode, item.onHand, item.decimalPrecision);
        }

        //show conflict information
        showVariantTransaction(variantId: Guid, productType: any, startOnhandDateTime: any, sku: string, productName: string, variantName: string, barCode:string, newOnHand: number, decimalPrecision: number) {
            var variantOnhandChange = {
                "variantId": variantId,
                "productInventoryType": productType,
                "startOnHandDateTime": startOnhandDateTime
            };
            var displayName = productName + this.replaceBarSymbol(variantName);
            this.dataService.customMethodData(`${this.baseEndPoint}/VariantOnHand/List`, "POST", variantOnhandChange).then((d) => {
                let variants = d.data;
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/inventoryCount/variantOnHandChange.modal.template.html",
                    controller: "meevo.plugins.inventoryCount.InventoryCountController",
                    controllerAs: "inventoryCountController",
                    bindToController: true,
                    locals: {
                        variants: variants,
                        displayName: displayName,
                        newOnHand: newOnHand,
                        decimalPrecision: decimalPrecision
                    }
                };
                this.modalService.showCustom(options);
            });
        }

        closeCustomModal(): void {
            this.modalService.hide();
            this.closeBarcodeScanner();
        }

        displaysearch() {
            if ((this.inventoryCount.id && this.inventoryCount.state == 1686) || (this.isCountStarted && this.isStateOpen())) {
                return true;
            } else {
                return false;
            }
        }

        takeBackup(): void {
            this.backupInventoryCount = angular.copy(this.inventoryCount);
        }

        resetInventoryCountChanges(): void {
            this.inventoryCount = angular.copy(this.backupInventoryCount);
        }
        clearLineItems() {
            this.holdLineItems[this.floorLocationId ? this.floorLocationId.toString() : '0'] = angular.copy(this.inventoryCount.lineItems);
            this.inventoryCount.lineItems = [];
        }

        filteredLineItems() : LineItems[] {
            if (!this.inventoryCount || !this.inventoryCount.lineItems) {
                return [];
            }
            if (!this.productVariantFilter) {
                return this.inventoryCount.lineItems;
            }
            return this.inventoryCount.lineItems.filter(x => `${x.productName}|${x.displayName}|${x.barCode}|${x.sku}`.toLowerCase().indexOf(this.productVariantFilter.toLowerCase()) > -1);
        }

        printableLineItems() : LineItems[] {
            // deleted items are hidden from non-print view with css for a collapsable height animation and fade out transition after mobile swipe removal
            return this.filteredLineItems().filter(x => !x.isDeleted); 
        }

        attachPrintListener() : void {
            // print template behind an ngif so we don't have to add another ng-repeat to DOM unnecessarily
            window.addEventListener('beforeprint', (event) => {
                setTimeout(() => {
                    this.isPrinting = true;
                    this.controller.$scope.$apply();
                }, 1);
            });

            window.addEventListener('afterprint', (event) => {
                setTimeout(() => {
                    this.isPrinting = false;
                    this.controller.$scope.$apply();
                }, 1);
            });
        }

        createNewCount(): void {
            this.mode = MaintenanceFormState.Adding;
            this.showSidebar();
            this.searchScreen = false;
            this.isCountStarted = true;
            this.chkShowNotCountedSince = false;
            this.floorLocationId = null;
            this.selectedFloorLocation = null;
            this.inventoryCount.lineItems = [];
            this.inventoryCount.state = InventoryCountStateEnum.Open;
            this.resetSearchCriteria();
            this.controller.viewSwitch('newCount');
            this.fixScrolling();
        }

        resetSearchCriteria() {
            this.productVariantFilter = "";
            this.includeDiscontinued = false;
            if (this.productSearchCriteria) {
                this.productSearchCriteria.floorLocationId = null;
                this.productSearchCriteria.showProdNotCntSince = null;
                this.productSearchCriteria.id = null;
            }
            this.selectedFloorLocation = null;
        }
        
        edit(): void {
            this.mode = MaintenanceFormState.Editing;
            this.isAutoSaveEnabled = true;
            this.showSidebar();
            this.attachMobileProductLookupHandler();
        }

        add(): void {
            this.mode = MaintenanceFormState.Adding;
            this.isAutoSaveEnabled = true;
        }

        cancel(): void {
            this.searchScreen = this.isAdding() ? true : false;
            
            if (this.isEditing()) {
                this.resetInventoryCountChanges();
                this.hideSidebar()
            }
            this.resetSearchCriteria();
            this.closeBarcodeScanner();
            this.makeReadonly();
            this.isDirty = false;
        }

        isAdding(): boolean {
            return this.mode == MaintenanceFormState.Adding;
        }

        isEditing(): boolean {
            return this.mode == MaintenanceFormState.Editing;
        }

        isReadonly(): boolean {
            return this.mode == MaintenanceFormState.Readonly;
        }
        
        back(): void {
            this.resetSearchCriteria();
            this.searchScreen = true;
            this.controller.viewSwitch('editCount');
        }

        isStateOpen(): boolean {
            if (!this.inventoryCount) return true;
            return this.inventoryCount.state == InventoryCountStateEnum.Open;
        }
        
        setupProductSearchCriteria(): void {
            this.productVariantFilter = "";
            this.productLookup = null;
            this.productSearchCriteria.productObjectState = Meevo.Model.ObjectStateEnum.Active;
            this.productSearchCriteria.productInventoryType = this.inventoryCount.productInventoryType;
            this.productSearchCriteria.variantObjectState = this.includeDiscontinued ?
                [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive] : [Meevo.Model.ObjectStateEnum.Active];
            this.productSearchCriteria.isInventoryTrackable = true;
            this.productSearchCriteria.floorLocationId = this.floorLocationId;
            this.syncSelectedFloorLocationFromId();
            this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;
            this.productSearchCriteria.id = this.inventoryCount.id;
            this.productSearchCriteria.inventoryCountOnly = this.inventoryCount.inventoryCountOnly;
            this.productSearchCriteria.iscounted = this.inventoryCount.iscounted;
            this.productSearchCriteria.manufacturerIds = this.inventoryCount.manufacturerIds;
            this.productSearchCriteria.distributorIds = this.inventoryCount.distributorIds;
            this.productSearchCriteria.productCatIds = this.inventoryCount.productCatIds;
            this.productSearchCriteria.showProdNotCntSince = this.inventoryCount.showProdNotCntSince;
            this.productSearchCriteria.chkShowNotCountedSince = this.inventoryCount.showProdNotCntSince ? true : false;             

            this.manufacturerMoverModel.collection = angular.copy(this.inventoryCount.manufacturerIds);
            this.manufacturerMoverModel.isAllSelected = (this.manufacturerMoverModel.collection.length == 0);
            this.distributorMoverModel.collection = angular.copy(this.inventoryCount.distributorIds);
            this.distributorMoverModel.isAllSelected = (this.distributorMoverModel.collection.length == 0);
            this.productCategoryMoverModel.collection = angular.copy(this.inventoryCount.productCatIds);
            this.productCategoryMoverModel.isAllSelected = (this.productCategoryMoverModel.collection.length == 0);

            this.createOrderByList();
        }

        private syncSelectedFloorLocationFromId(): ng.IPromise<any> {
            const id = this.productSearchCriteria && this.productSearchCriteria.floorLocationId;
            if (!id || id === Guid.empty) {
                this.selectedFloorLocation = null;
                return this.$q.resolve();
            }
            return this.dataService.getItem("floorLocation", id).then((floor: any) => {
                // PR 40287 review (M1): rapid-restore race guard. If the user
                // switched to a different count (or otherwise mutated the
                // criteria's floorLocationId) while this getItem was in flight,
                // productSearchCriteria.floorLocationId already reflects the
                // new state — skip the stale assignment so we don't overwrite
                // the current count's selected floor with the prior count's
                // name. Compare against the id we asked for, not the current
                // one, so out-of-order responses are correctly discarded.
                if (!this.productSearchCriteria || this.productSearchCriteria.floorLocationId !== id) {
                    return;
                }
                this.selectedFloorLocation = floor ? { id: floor.id, displayName: floor.displayName } : null;
            });
        }

        onFloorLocationChanged(): void {
            // Mirror what the old <md-select>'s two-way ng-model write did: copy the
            // chosen floor's id into productSearchCriteria.floorLocationId so downstream
            // search/holdLineItems logic observes the change. `this.floorLocationId` (the
            // class-level field on line 54) is intentionally untouched here — it is kept
            // in sync via performSearch and selectCount, matching pre-change semantics.
            const newId = (this.selectedFloorLocation && this.selectedFloorLocation.id)
                ? this.selectedFloorLocation.id
                : null;
            this.productSearchCriteria.floorLocationId = newId;
        }
        addIncludeDiscontinuedSearchCriteria() {

            this.productSearchCriteria.variantObjectState = this.includeDiscontinued ?
                [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive] : [Meevo.Model.ObjectStateEnum.Active];           
        }

        addWildCardToFilter(): void{
             this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;
        }

        /**
         * Search for product by barcode
         * */
        barcodeSearch(codes, silent: boolean = false): ng.IPromise<any> {
            console.log('barcodeScanMode', this.barcodeScanMode, codes);
            if (!codes || codes.length < 1) return;
            if (!silent) {
                this.busyService.start();
            }
            let foundCodes = angular.copy(codes);
            this.uniqueCodes = foundCodes.filter((item, i, ar) => item.trim() && ar.indexOf(item) === i);
            var unresolvedCode = false;
            // WI 130400: collect concrete-type lot-tracked cached scans so they open
            // ONE Assign Scanned Lots modal below, rather than letting each
            // handleBarcodeMatch -> divertIfLotTracked open its own (stacked) modal
            // when a single scan batch contains multiple already-cached lot codes
            // (e.g. a re-uploaded file). Mirrors how Device processMatches batches.
            var cachedLotTracked = [];
            var cachedHadNonLot = false;
            for (let index = 0; index < this.uniqueCodes.length; index++) {
                const code = this.uniqueCodes[index];
                if (this.barcodeScanResults[1].has(code)) {
                    var item = this.barcodeScanResults[1].get(code);
                    if (item.productInventoryType == this.currentInventoryType || item.productInventoryType == ProductInventoryTypeEnum.Other || !this.currentInventoryType) {
                        item.importCount = foundCodes.filter(code => code === item.barCode).length;
                        // Concrete-type lot variants batch into one modal (resolveScannedInventoryType
                        // flips the count type as handleBarcodeMatch's Retail/ShopSupply cases do).
                        // Non-lot items and unresolved-type (R/S) lot items still flow through
                        // handleBarcodeMatch, which saves the former and resolves the latter's type.
                        if (item.trackLots && item.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                            this.resolveScannedInventoryType(item);
                            cachedLotTracked.push(item);
                        } else {
                            if (!item.trackLots) { cachedHadNonLot = true; }
                            this.handleBarcodeMatch(item);
                        }
                    }
                }
                else {
                    unresolvedCode = true;
                }
            }
            if (cachedLotTracked.length > 0) {
                this.openScannedLotModal(cachedLotTracked, cachedHadNonLot);
            }
            if (!unresolvedCode) return this.$q.resolve();

            var request = {
                barCodes: this.uniqueCodes,
                returnInventoryTrackableOnly: true
            }
            return this.dataService.customMethodData(`${this.baseEndPoint}/BarcodeLookup/List`, "POST", request)
                .then((res: Array<LineItems> | any) => {
                    if (!silent) {
                        this.busyService.stop();
                    }

                    if (this.barcodeScanMode == BarcodeScanModes.Camera || this.barcodeScanMode == BarcodeScanModes.File) {
                        
                        let productVariant = res.data[0];
                        if (!productVariant) {
                            this.processUnsuccessfulBarcodeScan(this.uniqueCodes);
                            return this.$q.reject();
                        }

                        productVariant.importCount = foundCodes.filter(code => code === productVariant.barCode).length || 1;

                        console.log('single productVariant', productVariant);
                        
                        // check for exact match
                        if (foundCodes.some(x => x.toUpperCase().trim() == productVariant.barCode.toUpperCase().trim())) {
                            if ((this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Other && productVariant.productInventoryType !== ProductInventoryTypeEnum.Other) ||
                                (this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Retail && productVariant.productInventoryType == ProductInventoryTypeEnum.ShopSupply) ||
                                (this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.ShopSupply && productVariant.productInventoryType == ProductInventoryTypeEnum.Retail)) {
                                this.failSound.play();
                                this.modalService.alert('LABEL_INVALID_PRODUCT_INVENTORY_TYPE_SCANNED', Meevo.Components.Modal.ModalTranslationModes.Translate).then((res) => {
                                    this.recordBarcodeScanMismatch([productVariant.barCode]); // invalid for this session
                                    this.doBarcodeScannerOpen();
                                });
                                return null;
                            }

                            if (productVariant.variantId !== this.product.variantId) {
                                this.currentInventoryType = null; // reset if new product scanned
                            }

                            if (!this.inventoryCount.productInventoryType && productVariant.productInventoryType !== ProductInventoryTypeEnum.Other) { // count has no saved type at header level yet
                                var types;
                                if (productVariant.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                    types = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply];    
                                }
                                else {
                                    types = [productVariant.productInventoryType, ProductInventoryTypeEnum.RetailOrShopSupply];    
                                }

                                return this.openProductInventoryTypeModal(null, "LABEL_INVENTORY_COUNT_TYPE_CHOICE", null, types).then((data) => {
                                    if (data) {
                                        this.inventoryCount.productInventoryType = this.productSearchCriteria.productInventoryType = data;
                                        if (data !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            this.currentInventoryType = data;
                                            this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(x => x.productInventoryType == data && !x.isCounted);
                                        }
                                        // WI 130400 (E3): lot-tracked variants route to the
                                        // Assign Scanned Lots modal instead of the aggregate write.
                                        if (this.divertIfLotTracked(productVariant)) { return productVariant; }
                                        return this.handleBarcodeMatch(productVariant);
                                    }

                                }).catch(() => {
                                    return null;
                                });
                            }
                            else {
                                // WI 130400 (E3): lot-tracked variants route to the
                                // Assign Scanned Lots modal instead of the aggregate write.
                                if (this.divertIfLotTracked(productVariant)) { return productVariant; }
                                return this.handleBarcodeMatch(productVariant);
                            }
   
                        }
                        return res.data;
                    }
                    else if (this.barcodeScanMode == BarcodeScanModes.Device) {
                        var processMatches = () : ng.IPromise<any> => {
                            this.needsReconciliation = (!this.currentInventoryType || 
                                this.currentInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) &&
                                res.data.some(x => x.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply);

                            if (!this.inventoryCount.productInventoryType && (inventoryTypeBreakdown[ProductInventoryTypeEnum.RetailOrShopSupply] || 
                                (inventoryTypeBreakdown[ProductInventoryTypeEnum.Retail] && inventoryTypeBreakdown[ProductInventoryTypeEnum.ShopSupply]))) {
                                    this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                                }

                            // WI 130400 (F1): collect lot-tracked Device entries into
                            // ONE batch modal instead of letting the E3 single-divert
                            // guard fire per variant. Non-lot entries flow as before.
                            var lotTracked = [];
                            var nonLot = [];

                            for (const key in res.data) {
                                res.data[key].importCount = foundCodes.filter(code => code === res.data[key].barCode).length;
                                if (!this.needsReconciliation) {
                                    if (res.data[key].trackLots) {
                                        // Flip the count type for the scanned lot variant the same
                                        // way handleBarcodeMatch does for the non-lot branch below;
                                        // lot variants skip handleBarcodeMatch (WI 130400).
                                        this.resolveScannedInventoryType(res.data[key]);
                                        lotTracked.push(res.data[key]);
                                    } else {
                                        this.handleBarcodeMatch(res.data[key], false);
                                        nonLot.push(res.data[key]);
                                    }
                                }
                            }

                            if (this.needsReconciliation) {
                                this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                                return this.openBarcodeImportReconcilerModal(res.data).then((variants) => {
                                    console.log('res from openBarcodeImportReconcilerModal', variants);
                                    this.needsReconciliation = false;
                                    if (!variants) return this.$q.resolve();
                                    // WI 130400 (F1): collect lot-tracked typed entries into
                                    // ONE batch modal; non-lot entries flow through
                                    // processVariant as before. A R/S lot-tracked variant
                                    // contributes each typed split copy that has trackLots.
                                    for (const item of variants.filter(x => x.isCounted)) {
                                        if (item.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            var itemRetail = angular.copy(item);
                                            itemRetail.productInventoryType = ProductInventoryTypeEnum.Retail;
                                            itemRetail.importCount = itemRetail.retailImportCount;
                                            itemRetail.onHand = itemRetail.onHandRetail;
                                            itemRetail.productUsageType = itemRetail.productUsageTypeRetail;
                                            itemRetail.unitOfMeasureQuantity = 1;
                                            if (itemRetail.importCount > 0) {
                                                if (itemRetail.trackLots) {
                                                    lotTracked.push(itemRetail);
                                                } else {
                                                    this.processVariant(itemRetail, false);
                                                    nonLot.push(itemRetail);
                                                }
                                            }

                                            var itemShopSupply = angular.copy(item);
                                            itemShopSupply.productInventoryType = ProductInventoryTypeEnum.ShopSupply;
                                            itemShopSupply.importCount = itemShopSupply.shopImportCount;
                                            itemShopSupply.onHand = itemShopSupply.onHandShopSupply;
                                            itemShopSupply.productUsageType = itemShopSupply.productUsageTypeShopSupply;
                                            if (itemShopSupply.importCount > 0) {
                                                if (itemShopSupply.trackLots) {
                                                    lotTracked.push(itemShopSupply);
                                                } else {
                                                    this.processVariant(itemShopSupply, false);
                                                    nonLot.push(itemShopSupply);
                                                }
                                            }
                                        }
                                        else {
                                            if (item.importCount > 0) {
                                                if (item.trackLots) {
                                                    lotTracked.push(item);
                                                } else {
                                                    this.processVariant(item, false);
                                                    nonLot.push(item);
                                                }
                                            }
                                        }
                                    }
                                    var hadNonLot = nonLot.length > 0;
                                    // Open the Assign Scanned Lots modal only AFTER the save
                                    // re-hydrates the line items (onComplete), so the modal sees
                                    // each variant's real current lots — not the stale pre-save
                                    // count (WI 130400 race fix).
                                    this.saveInventoryCount(true, (this.scannerOpened == 'mobile'), () => {
                                        if (lotTracked.length >= 1) {
                                            this.openScannedLotModal(lotTracked, hadNonLot);
                                        }
                                    });
                                    this.successSound.play();
                                });
                            }
                            else {
                                var hadNonLotElse = nonLot.length > 0;
                                // See race-fix note above: modal opens in onComplete, after the
                                // line-item re-hydrate, so existing lots are seeded correctly.
                                this.saveInventoryCount(true, (this.scannerOpened == 'mobile'), () => {
                                    if (lotTracked.length >= 1) {
                                        this.openScannedLotModal(lotTracked, hadNonLotElse);
                                    }
                                });
                                this.successSound.play();
                            }

                            return this.$q.resolve();
                        }

                        var handleBadVariants = () : ng.IPromise<any> => {
                            return this.modalService.alert(this.$translate.instant('LABEL_INVENTORY_COUNT_INVALID_INVENTORY_TYPE_SCANNED', {
                                'productInventoryType': this.$translate.instant(`ENUM_LABEL_${this.inventoryCount.productInventoryType || ProductInventoryTypeEnum.RetailOrShopSupply}`), 
                                'badVariants': badVariants.displayString})).then(() => {
                                    res.data = res.data.filter(x => !badVariants.ids.some(y => y == `${x.variantId}${x.productInventoryType}`));
                                    return processMatches();
                            });
                        }

                        var handleNotFoundBarcodes = (codes) : ng.IPromise<any> => {
                            this.failSound.play();
                            return this.modalService.alert(this.$translate.instant('LABEL_INVENTORY_COUNT_BARCODE_NOT_FOUND',{
                                'notFoundBarcodes': `<br /><br /> ${codes.join('<br />')}`
                            }), ModalTranslationModes.Translate, false, { okButtonContentKey: 'LABEL_CONTINUE' });
                        }                  

                        //console.log('productVariant in bulk found', res.data);

                        let inventoryTypeBreakdown = this.getInventoryTypeBreakdown(res.data);

                        var badVariants = { displayString:"", ids: [] };
                        var notFoundBarcodes = this.uniqueCodes.filter(x => !res.data.some(y => y.barCode.toLowerCase() === x.toLowerCase()));
                        console.log('notFoundBarcodes', notFoundBarcodes)

                        var removeMiscSupplyVariants = (this.inventoryCount.productInventoryType
                                                            && this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other
                                                            && inventoryTypeBreakdown[ProductInventoryTypeEnum.Other])
                                                        || (this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other
                                                            && inventoryTypeBreakdown[ProductInventoryTypeEnum.Other] < res.data.length);

                        for (let element of res.data) {
                            if (removeMiscSupplyVariants && element.productInventoryType == ProductInventoryTypeEnum.Other) {
                                    badVariants.displayString += `<br />${this.getLineItemDisplayName(element)}`;
                                    badVariants.ids.push(`${element.variantId}${element.productInventoryType}`);
                            }
                            else if (this.inventoryCount.productInventoryType && 
                                    this.inventoryCount.productInventoryType != element.productInventoryType &&
                                    this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                                        if (element.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            element.productInventoryType = this.inventoryCount.productInventoryType;
                                        }
                                        else {
                                            badVariants.displayString += `<br />${this.getLineItemDisplayName(element)}`;
                                            badVariants.ids.push(`${element.variantId}${element.productInventoryType}`);
                                        }
                            } 
                        }

                        if (notFoundBarcodes.length > 0) {
                            return handleNotFoundBarcodes(notFoundBarcodes).then(() => {
                                if (badVariants.ids.length > 0) {
                                    return handleBadVariants();
                                } else {
                                    return processMatches();
                                }
                            })
                        }
                        else if (badVariants.ids.length > 0) {
                            return handleBadVariants();
                        }
                           
                        return processMatches();                  

                    }
                    else {
                        return [];
                    }
                })
                .catch(() => {
                    if (!silent) {
                        this.busyService.stop();
                    }
                    return false;
                });
        }
        

        processVariant = (variant, doAutoSave = true) : any => {
            variant = this.incrementCount(variant);
            this.updateProductAndUpdateCount(variant, true);
            this.highlightAddedItem(variant);
            if (doAutoSave) {
                this.handleAutoSave(variant);
                this.successSound.play();
            }
            return variant
        }

        getInventoryTypeBreakdown(data) : any {
            return data.reduce((p, c) => {
                var name = c.productInventoryType
                if (!p.hasOwnProperty(name)) {
                  p[name] = 0;
                }
                p[name]++;
                return p;
              }, {});
        }

        handleBarcodeMatch(productVariant, doAutoSave: boolean = true) : any {
            
            console.log('handleBarcodeMatch', this.barcodeScanMode, productVariant);
            switch (productVariant.productInventoryType) {
                case ProductInventoryTypeEnum.RetailOrShopSupply:
                    if (this.currentInventoryType || this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Retail || this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                        productVariant.productInventoryType = this.currentInventoryType || this.inventoryCount.productInventoryType;
                        // WI 130400 (E3): type now resolved to a single R/S type —
                        // lot-tracked variants route to Assign Scanned Lots.
                        if (this.divertIfLotTracked(productVariant)) { return productVariant; }
                        this.processVariant(productVariant, doAutoSave);
                        return productVariant;
                    } else {
                        var scannerOpened = this.scannerOpened;
                        if (this.scannerOpened == 'desktop') {
                            // about to open another md-dialog
                            this.closeBarcodeScanner();
                        } 

                        if (!this.needsReconciliation) {
                            var types = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply];
                            return this.openProductInventoryTypeModal(productVariant, "LABEL_INVENTORY_COUNT_TYPE_LINEITEM_CHOICE", "LABEL_INVENTORY_COUNT_TYPE_LINEITEM_CHOICE_NOTE", types).then((data : ProductInventoryTypeEnum) => {
                                if (!data) return;
                                
                                this.currentInventoryType = data;
                                if (this.currentInventoryType !== this.productSearchCriteria.productInventoryType && productVariant.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                                    this.setProductSearchCriteria(this.currentInventoryType);
                                }
                                productVariant.productInventoryType = data;
                                // WI 130400 (E3): type now resolved via picker —
                                // lot-tracked variants route to Assign Scanned Lots.
                                if (this.divertIfLotTracked(productVariant)) {
                                    this.doBarcodeScannerOpen();
                                    this.scannerOpened = scannerOpened;
                                    return productVariant;
                                }
                                productVariant = this.processVariant(productVariant, doAutoSave);

                                this.doBarcodeScannerOpen();
                                this.scannerOpened = scannerOpened;
                                return productVariant;
                            }).catch(() => {
                                return null;
                            });
                        }
                    }
                    break;
                case ProductInventoryTypeEnum.Other:
                    if (!this.inventoryCount.productInventoryType) {
                        this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(x => x.productInventoryType == ProductInventoryTypeEnum.Other && !x.isCounted);
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.Other);
                    } else if (this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other) {
                        this.failSound.play();
                        this.modalService.alert('LABEL_INVALID_PRODUCT_INVENTORY_TYPE_SCANNED', Meevo.Components.Modal.ModalTranslationModes.Translate).then((res) => {
                            this.doBarcodeScannerOpen();
                        });
                        return null;
                    }
                    break;
                case ProductInventoryTypeEnum.Retail:
                    if (this.currentInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                    } else if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.Retail);
                    }
                    if (this.barcodeScanMode == BarcodeScanModes.Camera) {
                        this.openBarcodeScanner(this.scannerOpened);
                    }
                    
                    break;
                case ProductInventoryTypeEnum.ShopSupply:
                    if (this.currentInventoryType == ProductInventoryTypeEnum.Retail) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                    } else if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.ShopSupply);
                    }
                    if (this.barcodeScanMode == BarcodeScanModes.Camera) {
                        this.openBarcodeScanner(this.scannerOpened);
                    }
                    break;
                default:
                    return null;
                    
            }
            if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                this.currentInventoryType = productVariant.productInventoryType;
            }

            // WI 130400 (E3): primary defense — type is resolved to a single
            // value here (Retail/ShopSupply/Other), so a lot-tracked variant
            // routes to Assign Scanned Lots instead of the aggregate write.
            // This also catches the cached-barcode path (top loop calls
            // handleBarcodeMatch directly) before it can reach incrementCount.
            if (this.divertIfLotTracked(productVariant)) { return productVariant; }

            this.processVariant(productVariant, doAutoSave);
            return productVariant;
        }

        setProductSearchCriteria(value) {
            this.productSearchCriteria['productInventoryType'] = value;
            this.generateProductLookupCriteria();
            this.createOrderByList();
        }

        // WI 130400: flip the count's inventory type to a scanned variant's concrete
        // type, mirroring handleBarcodeMatch's Retail/ShopSupply cases (setProductSearchCriteria
        // + the post-switch currentInventoryType assignment). Lot-tracked variants are
        // batched straight into the Assign Scanned Lots modal and never pass through
        // handleBarcodeMatch, so without this a Shop Supply lot scanned into a
        // Retail/empty count never flips the type: the line saves as ineligible for a
        // Retail count, the server drops it (the counted product never shows in the
        // grid), and the next scan trips the "invalid inventory type" import guard.
        // A mix of Retail + ShopSupply across scans resolves to RetailOrShopSupply,
        // exactly like the non-lot path. Other / RetailOrShopSupply variants are left
        // to their own paths (the type picker / reconciler).
        resolveScannedInventoryType(variant: any): void {
            if (!variant) return;
            var t = variant.productInventoryType;
            if (t != ProductInventoryTypeEnum.Retail && t != ProductInventoryTypeEnum.ShopSupply) {
                return;
            }
            var other = (t == ProductInventoryTypeEnum.Retail)
                ? ProductInventoryTypeEnum.ShopSupply
                : ProductInventoryTypeEnum.Retail;
            if (this.currentInventoryType == other) {
                this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
            } else if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                this.setProductSearchCriteria(t);
            }
            if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                this.currentInventoryType = t;
            }
        }

        incrementCount(product): any {
            var ndx = this.inventoryCount.lineItems.findIndex(x => x.variantId == product.variantId &&  x.productInventoryType == product.productInventoryType)
            if (ndx > -1) {
                var lineItem = this.inventoryCount.lineItems[ndx];
                lineItem.isCounted = true;
                lineItem.actualCount = this.roundingService.add(lineItem.actualCount, product.importCount);
                lineItem.totalActualCountDisplay = this.getTotalActualCount(lineItem);
                if (lineItem.totalActualCountDisplay > 0) {
                    lineItem.isDeleted = false;
                }

                if (!lineItem.inventoryCountLineItemModalList) {
                    lineItem.inventoryCountLineItemModalList = [];
                }
                if (this.tenantEnableProductUsageTracking
                    && lineItem.enableProductUsageTracking
                    && lineItem.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount) {
                    // add modal data
                    let newIndex = lineItem.inventoryCountLineItemModalList.length;
                    lineItem.inventoryCountLineItemModalList[newIndex] = {
                        sortOrder: newIndex,
                        productInventoryType: lineItem.productInventoryType,
                        variant_TId: lineItem.variantId || lineItem.id,
                        productUsageType: Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct,
                        quantity: product.importCount,
                        floor_LId: this.inventoryCount.floorLocationId,
                    };
                }
                return lineItem;
            } else {
                product.isCounted = true;
                product.actualCount = product.importCount;
                product.totalActualCountDisplay = this.getTotalActualCount(product);
                if (product.totalActualCountDisplay > 0) {
                    product.isDeleted = false;
                }

                if (!product.inventoryCountLineItemModalList) {
                    product.inventoryCountLineItemModalList = [];
                }
                if (this.tenantEnableProductUsageTracking
                    && product.enableProductUsageTracking
                    && product.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount) {
                    // add modal data
                    let newIndex = product.inventoryCountLineItemModalList.length;
                    product.inventoryCountLineItemModalList[newIndex] = {
                        sortOrder: newIndex,
                        productInventoryType: product.productInventoryType,
                        variant_TId: product.variantId || product.id,
                        productUsageType: Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct,
                        quantity: product.importCount,
                        floor_LId: this.inventoryCount.floorLocationId,
                    };
                }

                return product;
            }
        }
        
        resetInventoryCount(): void {
            this.holdLineItems = {};
            this.inventoryCount = {
                id: null,
                displayName: "",
                floorLocationId: null,
                dateCreated: null,
                dateUpdated: null,
                entityVersion: 0,
                productInventoryType: null,
                lineItems: null,
                state: null,
                userName: "",
                iscounted: null,
                inventoryCountOnly: false,
                orderItemsBy: "ManufacturerName",
                distributorIds: [],
                manufacturerIds: [],
                productCatIds: []
            };

            this.distributorMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.manufacturerMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.productCategoryMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.barcodeScanResults = { 0: [ ], 1: new Map() };
        }

        setInventoryCountDefaults(): void {
            let today = moment();
            this.inventoryCount.displayName = "Count on " + this.meevoDateFilter(moment().toDate());
            this.setProductSearchCriteria(ProductInventoryTypeEnum.Retail);
            this.productSearchCriteria.iscounted=null
           // this.inventoryCount.iscounted = null;
            this.isNewCount = true;
        }

        getSearchCriteria(pageNum, itemsPerPage) {
            this.productSearchCriteria.manufacturerIds = this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection;
            this.productSearchCriteria.distributorIds = this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection;
            this.productSearchCriteria.productCatIds = this.productCategoryMoverModel.isAllSelected ? [] : this.productCategoryMoverModel.collection;
            this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;

            return {
                pageNumber: pageNum,
                itemsPerPage: itemsPerPage,
                criteria: this.productSearchCriteria,
                sortBy: this.getSearchCriteriaSortBy()
            };
        }

        getSearchCriteriaSortBy() {
            if ((this.inventoryCount.orderItemsBy = this.inventoryCountOrder = this.inventoryCountSortOption.fieldName) == this.secondaryCountOrder) {
                return this.inventoryCountSortOption.fieldName;
            } else {
                return `${this.inventoryCountSortOption.fieldName}, ${this.secondaryCountOrder}`
            }
        }

        searchButtonClicked() {
            this.hideSidebar();
            this.search();
        }

        search() {
            this.inventoryCount.floorLocationId = this.productSearchCriteria.floorLocationId;
            this.controller.viewSwitch('count');
            this.productSearchCriteria.id = this.inventoryCount.id;
            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            // Capture the key clearLineItems() is about to snapshot under -- it reads
            // this.floorLocationId (the OLD floor; search() never updates that field,
            // only performSearch()'s response handler does). floorLocationKey reads
            // productSearchCriteria.floorLocationId, which is already the NEW floor by
            // the time the restore below runs. Reusing the getter there would read a
            // different bucket than clearLineItems() wrote to whenever a floor change
            // and Search happen together.
            const heldKey = this.floorLocationId ? this.floorLocationId.toString() : '0';
            this.clearLineItems();
            this.inSaveProcess = true;
            this.busyService.start();

            this.ensureInventoryTypeSeeded();

            return this.performSearch(0)
                .then(() => {
                    if (this.inventoryCount) {
                        // Search must be additive: clearLineItems() moved everything
                        // already in the count into holdLineItems before performSearch
                        // rebuilt lineItems from the (Active-only) search results alone.
                        // Anything already in the count that the search criteria doesn't
                        // match -- most notably a product already added but deleted at
                        // this location -- must be restored here rather than silently
                        // dropped. WI 141611: before that fix, a deleted item happened to
                        // reappear in the search results too (the bug being fixed), so it
                        // survived this rebuild by accident; now it doesn't.
                        const held = this.holdLineItems[heldKey] || [];
                        const present = new Set(this.inventoryCount.lineItems.map(li => `${li.variantId}|${li.productInventoryType}`));
                        let appended = false;
                        held.forEach((item: LineItems) => {
                            const key = `${item.variantId}|${item.productInventoryType}`;
                            if (!present.has(key) && !item.isDeleted) {
                                this.inventoryCount.lineItems.push(item);
                                present.add(key);
                                appended = true;
                            }
                        });
                        // Restored items land at the end of the array, out of sort
                        // order -- the table has no orderBy filter (relies on array
                        // order, matching the server's ORDER BY on a normal fetch).
                        // Only re-sort when something was actually restored; the
                        // common case (nothing held back) shouldn't pay for it.
                        if (appended) {
                            this.sortLineItemsByOrder(this.inventoryCount.lineItems, this.inventoryCount.orderItemsBy);
                        }
                        this.inventoryCountOrder = this.inventoryCountSortOption.fieldName = this.inventoryCount.orderItemsBy;
                    }
                }).catch((error) => {

                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                    this.generateProductSplitFields();
                    //let trackInfo: Model.TrackingItem = 
                    this.trackingService.saveTrackingInfo(new Model.TrackingItem(Model.NounEnum.InventoryCountPage,
                                                                                 Model.VerbEnum.SearchButtonClicked,
                                                                                 this.productSearchCriteria));
                });
        }

        // Mirrors the server's @FieldOrderBy mapping (udf_SqlScript_Location_List_GetV2)
        // from orderItemsBy's server-side field names to this DTO's client property
        // names, so a client-side re-sort after search() restores an item lands it
        // where a fresh server fetch would have put it. Always ties off on sku, same
        // as the server appending ',SKU' when the field list doesn't already have it.
        // No 'SupplyCategory' entry: the server UDF's own field-mapping table has no
        // match for it either, so that term silently drops out of the real ORDER BY --
        // mapping it client-side would sort by a field the server never actually did.
        private static readonly ORDER_FIELD_MAP: { [key: string]: string } = {
            'VariantBarCode': 'barCode',
            'DisplayName': 'displayName',
            'ManufacturerName': 'manufacturer',
            'ProductCategory': 'category',
            'ProductSubCategory': 'subCategory',
            'VariantSku': 'sku'
        };

        sortLineItemsByOrder(items: LineItems[], orderItemsBy: string): void {
            if (!items || items.length === 0) return;
            var keys: string[] = (orderItemsBy || '').split(',')
                .map(k => InventoryCountContext.ORDER_FIELD_MAP[k.trim()])
                .filter(k => !!k);
            if (keys.indexOf('sku') === -1) {
                keys.push('sku');
            }
            items.sort((a, b) => {
                for (var i = 0; i < keys.length; i++) {
                    var av = a[keys[i]], bv = b[keys[i]];
                    if (av == null && bv == null) continue;
                    if (av == null) return -1;
                    if (bv == null) return 1;
                    if (av < bv) return -1;
                    if (av > bv) return 1;
                }
                return 0;
            });
        }

        sumObjectProperties(items, prop) : number {
            return items.reduce((a, b) => {
                return this.roundingService.add(a, b[prop], this.decimalPrecision);
            }, 0);
        };

        getHeldCountForAllFloorLocations(obj: LineItems): { actualCount: number, actualCountUnits?: number } {
            var matchedItems = [];
            var returnCount = { actualCount: 0, actualCountUnits: null };

            Object.keys(this.holdLineItems).forEach(key => {
                var item = this.holdLineItems[key].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && x.isCounted);
                if (item && item.floorLocationId) {
                    matchedItems.push(item);
                }
            });

            if (matchedItems.length > 0) {
                returnCount.actualCount = this.sumObjectProperties(matchedItems, "actualCount");
                returnCount.actualCountUnits = this.sumObjectProperties(matchedItems, "actualCountUnits");
            }
            else {
                var item = this.holdLineItems['0'].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && x.isCounted);
                returnCount.actualCount = item ? item.actualCount : obj.actualCount;
                returnCount.actualCountUnits = item ? item.actualCountUnits : obj.actualCountUnits;
            }

            return returnCount;
        }

        performSearch(pageNumber: number = 0): ng.IPromise<any> {
            return this.dataService.customMethodData(`${this.baseEndPoint}/ProductVariant/List`, "POST", this.getSearchCriteria(pageNumber, this.itemsPerPage))
                .then((response) => {
                    if (response && response.data && response.data.length > 0) {
                        this.floorLocationId = this.productSearchCriteria.floorLocationId;
                        if (this.floorLocationKey == "0") {
                            response.data.forEach((obj: LineItems) => {
                                let returnCount = this.getHeldCountForAllFloorLocations(obj);
                                obj.actualCount = returnCount.actualCount;
                                obj.actualCountUnits = returnCount.actualCountUnits;
                                obj.totalActualCountDisplay = this.getTotalActualCount(obj);
                                let item = this.holdLineItems['0'].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType);
                                obj.isCounted = item ? item.isCounted : obj.actualCount > 0;
                                let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                obj.decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                            });
                        }
                        else if (this.holdLineItems[this.floorLocationKey]) {
                            this.holdLineItems[this.floorLocationKey].forEach((obj: LineItems) => {
                                const index = response.data.findIndex((x: LineItems) => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && obj.isCounted);
                                if (index >= 0) {
                                    response.data[index].actualCount = obj.actualCount;
                                    response.data[index].actualCountUnits = obj.actualCountUnits;
                                    response.data[index].totalActualCountDisplay = this.getTotalActualCount(obj);
                                    response.data[index].isCounted = obj.isCounted;
                                    let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                    response.data[index].decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                                }
                            });
                        }
                        else {
                            response.data.forEach((obj: LineItems) => {
                                obj.totalActualCountDisplay = this.getTotalActualCount(obj);
                                let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                obj.decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                            });
                        }
                        // Hydrate the lot Count-column display for every result.
                        // lotCountDisplay is a host-only computed field —
                        // raw server payloads don't carry it, so without this
                        // the lot-tracked cell renders `(undefined || 0)` after
                        // every filter Search. Mirrors the same hydration in
                        // selectCount() and the post-save handler in
                        // saveInventoryCountWorker. Filter-aware: when a floor
                        // is active, computeLotCountDisplay sums the per-floor
                        // lot rows for that floor; otherwise the variant
                        // aggregate.
                        response.data.forEach((obj: LineItems) => {
                            obj.lotCountDisplay = obj.trackLots ? this.computeLotCountDisplay(obj) : 0;
                        });
                        this.inventoryCount.lineItems.push(...response.data);
                        if (response.data.length >= this.itemsPerPage) {
                            return this.performSearch(++pageNumber);
                        }
                    }
                    return this.inventoryCount.lineItems;
                });
        }

        selectCount(count: Meevo.Model.InventoryCount): ng.IPromise<any> {
            this.controller.viewSwitch('count');
            // Preserve any active floor filter going into this call so a
            // post-save selectCount keeps the user's chosen scope. The
            // pre-FA4 unconditional reset to null caused lot-tracked count
            // cells to flip from per-floor (e.g. 1) to variant-aggregate
            // (e.g. 3) after every save, even though the search-pane
            // dropdown still showed the active floor — confusing UX.
            // Only clear if there's no filter to preserve (e.g. switching
            // counts via the count list).
            const preservedFloorId = (this.productSearchCriteria
                                      && this.productSearchCriteria.floorLocationId
                                      && this.productSearchCriteria.floorLocationId !== Guid.empty)
                ? this.productSearchCriteria.floorLocationId
                : null;
            return this.dataService.customMethodData(`${this.baseEndPoint}/${count.id}`, "GET", null).then((d) => {
                d.data.lineItems.map(product => {
                    product.imageURL = this.getImageURL(product);
                });
                this.productSearchCriteria.floorLocationId = preservedFloorId;
                this.floorLocationId = preservedFloorId;
                this.syncSelectedFloorLocationFromId();
                this.isAutoSaveEnabled = true;
                this.inventoryCount = d.data;
                this.holdLineItems = {};
                this.inventoryCountOrder = this.inventoryCountSortOption.fieldName = this.inventoryCount.orderItemsBy;
                var tempCount = 0;
                if (this.inventoryCount != null && this.inventoryCount.lineItems.length > 0) {
                    for (var i = 0; i < this.inventoryCount.lineItems.length; i++) {
                        let li = this.inventoryCount.lineItems[i];
                        if (li.objectState == Meevo.Model.ObjectStateEnum.Inactive)
                            tempCount++;
                        if ((!li.isOverride
                            && li.productVariantsPerFloorLocation != null
                            && li.productVariantsPerFloorLocation.length > 0
                            && this.inventoryCount.state != InventoryCountStateEnum.Complete)
                            || (li.isOverride
                                && (count.floorLocationId != null && count.floorLocationId != Guid.empty)
                                && this.inventoryCount.state != InventoryCountStateEnum.Complete)
                        ) {
                            let sumData = this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation);
                            li.actualCount = sumData.actualCountSum;
                            li.actualCountUnits = sumData.actualCountUnitsSum;
                        }
                        li.totalActualCountDisplay = this.getTotalActualCount(li);
                        let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                        li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                        // Hydrate the Count-column lot total. Without this the
                        // value next to the pencil is blank on initial load
                        // and only populates after the user opens the modal
                        // and clicks Apply (which calls applyLotAllocations).
                        li.lotCountDisplay = li.trackLots ? this.computeLotCountDisplay(li) : 0;
                        // WI 124174: derive a row-local boolean from the
                        // server-supplied productObjectState so the table
                        // template can bind a single flag for the red
                        // strikethrough class + read-only gating, without
                        // re-evaluating the enum comparison per cell.
                        //
                        // Gate on the PARENT PRODUCT's Deleted state: the
                        // "delete a product" workflow cascades to flipping
                        // every variant on the deleted product to Inactive
                        // while leaving the product itself in Deleted
                        // state. That pair is what the user must remove
                        // before commit. Plain discontinued variants
                        // (product Active + variant Inactive) — including
                        // variants entered via the includeDiscontinued
                        // flow — stay countable; this flag stays false for
                        // them so no strikethrough/read-only applies.
                        li.isVariantDeleted =
                            li.productObjectState === Meevo.Model.ObjectStateEnum.Deleted;
                    }

                    if (tempCount > 0)
                        this.includeDiscontinued = true;
                    else this.includeDiscontinued = false;

                }

                this.setupProductSearchCriteria();
                this.generateProductLookupCriteria();
                this.takeBackup();
                this.productSearchCriteria.iscounted = null;
                this.makeReadonly();
                this.searchScreen = false;
                if (this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT')
                    this.isConflict = true;
                else
                    this.isConflict = false;

                this.isNewCount = false;

                this.checkForDisabledUsage();
                
            });
        }

        checkForDisabledUsage() {
            if (this.inventoryCount != null && this.inventoryCount.lineItems.length > 0) {
                var itemsToBeAdjusted = this.inventoryCount.lineItems.filter((item) => item.inventoryCountLineItemModalList.length && !this.isProductUsageEnabled(item));
                if (itemsToBeAdjusted.length > 0) {
                    itemsToBeAdjusted.forEach(item => {
                        item.decimalPrecision = this.decimalPrecision;
                        let partial: number = item.actualCountUnits ? this.roundingService.divideNormalizedNumbers(item.actualCountUnits, item.unitOfMeasureQuantity, item.decimalPrecision) : 0;
                        item.actualCount = item.actualCount + Math.trunc(partial);
                        item.totalActualCountDisplay = this.getTotalActualCount(item);
                        item.inventoryCountLineItemModalList = [];
                    });
                    return this.modalService.alert('MESSAGE_INVENTORY_COUNT_PRODUCT_USAGE_DISABLED', ModalTranslationModes.Translate);
                }
            }
        }

        sumFloorLocationActualCount(productVariantsPerFloorLocation: any): { actualCountSum: number, actualCountUnitsSum?: number } {
            var sum = { actualCountSum: 0, actualCountUnitsSum: null };
            productVariantsPerFloorLocation.forEach(fl=> {
                sum.actualCountSum += fl.perFloorLocationActualCount;
                sum.actualCountUnitsSum += fl.perFloorLocationActualCountUnits;
            });

            return sum;
        }

        searchForInventoryCounts(state: InventoryCountStateEnum): void {
            this.isFilterByComplete = state === InventoryCountStateEnum.Complete ? true : false;

            var data = { "criteria": { "state": state } };
            this.dataService.customMethodData(`${this.baseEndPoint}/List`, "POST", data).then((d) => {
                this.inventoryCounts = d.data;
            });
        }

        /**
         * Get product image link
         * @param {any} product
         * @returns {string} image url
         * */
         getImageURL(product: any): string {
            let imageURL = '';

            if (product && product.meevoFile && product.meevoFile.files.length > 0) {
                let files = product.meevoFile.files;

                for (let i in files) {
                    if (files[i].key === 'Source') {
                        imageURL = files[i].fileUrl;
                    }
                }
            }

            return imageURL;
        }

        // parameter is used for Desktop Version
        updateProductAndUpdateCount(prod?: any, fromBarcode: boolean = false): void {
            // Desktop Version calulate the originalActualCount because this is no longer handled by the function qtyUpdateModal()'s
            // (found in the Inventory Count Controller) modal resolve function
            if (prod != null) {
                this.product = prod;

                if (prod.actualCount != 0)
                    prod.recentlyChanged = 1;
                else
                    prod.recentlyChanged = 0;
            }

            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                for (let i = 0; i < this.inventoryCount.lineItems.length; i++) {
                    if (this.product != null
                        && this.inventoryCount.lineItems[i].variantId == this.product.variantId
                        && this.inventoryCount.lineItems[i].productInventoryType == this.product.productInventoryType) {
                        this.originalActualCount = this.inventoryCount.lineItems[i].actualCount;
                        this.inventoryCount.lineItems[i].isCounted = true;
                    }
                }
            }

            if (this.product != null && this.product.variantId != null) {
                this.product.imageURL = this.getImageURL(prod);

                this.lineItem = this.getLineItem(this.product);

                // if statement and for loop below determine wether or not to add a new product or update an existing one
                let addNewProduct = true;
                if (this.inventoryCount.lineItems != null) {
                    for (let i = 0; i < this.inventoryCount.lineItems.length; i++) {
                        if (this.inventoryCount.lineItems[i].variantId == this.lineItem.variantId
                            && this.inventoryCount.lineItems[i].productInventoryType == this.lineItem.productInventoryType) {
                            if (this.floorLocationId && this.floorLocationId != Guid.empty) {
                                this.inventoryCount.lineItems[i].floorLocationId = this.floorLocationId;
                            }

                            if (!fromBarcode) {
                                this.inventoryCount.lineItems[i].actualCount = this.product.actualCount;
                            }

                            if (prod == null) {
                                this.inventoryCount.lineItems[i].actualCount = this.product.actualCount;
                            }

                            this.inventoryCount.lineItems[i].isDirty = true;
                            addNewProduct = false; //found existing product within the Count details
                            i = 99999;
                            break;
                        }
                    }
                }

                if (addNewProduct) {
                    if (this.inventoryCount.lineItems == null) {
                        this.inventoryCount.lineItems = [];
                    }

                    if (this.inventoryCount.lineItems.length == 0) {
                        this.inventoryCount.productInventoryType = this.product.productInventoryType;
                    }

                    if (!this.inventoryCount.lineItems.some(x => x.variantId == this.lineItem.variantId && x.productInventoryType == this.lineItem.productInventoryType)) {
                        this.lineItem.isDirty = true;
                        this.inventoryCount.lineItems.unshift(this.lineItem);
                    }
                }

                // if the product is null then save to DB because this is the behavior for the mobile version auto save mode
                if (prod == null) {
                    this.updateCountDetail(this.lineItem);
                }
            }
        }

        getLineItem(product) : LineItems {
            return this.prepareLineItemForSaving({
                actualCount: product.actualCount,
                actualCountUnits: product.actualCountUnits,
                id: this.inventoryCount.id,
                variantId: product.variantId,
                manufacturer: product.manufacturer,
                category: product.category,
                subCategory: product.subCategory,
                supplyCategoryEnum: product.supplyCategoryEnum,
                productName: product.productName,
                displayName: product.displayName,
                product_TId: product.product_TId,
                productInventoryType: product.productInventoryType,
                wholeSale: product.wholeSale,
                endOnHand: product.onHand,
                startOnHand: product.onHand,
                isCounted: product.isCounted,
                imageURL: product.imageURL,
                objectState: 2026,
                barCode: product.barCode,
                sku: product.sku,
                onHand: product.onHand,
                onHandDateTime: product.onHandDateTime,
                // Source the floor scope from productSearchCriteria — the
                // canonical filter state — not from inventoryCount, which
                // gets clobbered to null whenever a GET refresh replaces it
                // (the server's GetWithFloorAsync(id, null) doesn't echo the
                // host's filter back). Reading the stale null here would
                // route a per-floor autosave through the no-floor save path,
                // writing IsOverride=1 to Detail_L and bypassing the
                // PerFloorLocation tables entirely. A later per-floor save
                // then re-derives Detail.ActualCount from one floor's sum
                // and the variant total drifts, triggering a spurious
                // conflict at commit.
                floorLocationId: (this.productSearchCriteria
                                  && this.productSearchCriteria.floorLocationId
                                  && this.productSearchCriteria.floorLocationId != Guid.empty)
                    ? this.productSearchCriteria.floorLocationId
                    : null,
                productVariantsPerFloorLocation: angular.copy(product.productVariantsPerFloorLocation),
                isDeleted: product.isDeleted,
                isAutosave: this.isAutoSaveEnabled,
                entityVersion: product.entityVersion,
                isDirty: product.isDirty,
                inventoryCountLineItemModalList: angular.copy(product.inventoryCountLineItemModalList),
                totalActualCountDisplay: product.totalActualCountDisplay,
                enableProductUsageTracking: product.enableProductUsageTracking,
                productUsageType: product.productUsageType,
                // FA4 — lot-tracking flags are required on the line-item model
                // because every downstream lot helper (getLotPencilState,
                // computeLotCountDisplay, openLotModal) keys off them. Default
                // to false here so non-lot variants opt out cleanly. The C# wire
                // DTO populates both for hydrated lines.
                trackLots: !!product.trackLots,
                trackExpirationDate: !!product.trackExpirationDate,
                // WI 117621: variant-aggregate lot rows. applyLotAllocations
                // (per-floor or variant) rebuilds product.lots after every
                // modal Apply; without copying it here, the autosave POST
                // strips lots and the SP rejects with rule 3 ("lot-tracked
                // variants with ActualCount > 0 must have matching lot rows
                // in @VariantUpdateLotList").
                lots: angular.copy(product.lots),
            });
        }

        filterVariantbyFloorLocation(): void {
            // WI 117621: previously this method filtered each line item's
            // productVariantsPerFloorLocation array down to ONLY the active
            // floor's entry. That broke per-floor lot tracking: the next
            // save would re-send the variant-aggregate lots rebuilt from
            // only the active floor's per-floor entry, clobbering other
            // floors' lot rows server-side. The full per-floor array is now
            // kept in memory; consumers that need active-floor-only data
            // filter inline at the call site (count column display, modal
            // open path, etc.).

            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0)
                this.inventoryCount.lineItems.forEach(li=> {
                    li.floorLocationId = this.floorLocationId;
                    if (li.floorLocationId == null || li.floorLocationId == Guid.empty)
                        li.isOverride = true;
                    else {
                        // Find or create only the active floor's per-floor
                        // entry. Other floors' entries are left untouched
                        // so their per-floor counts (and per-floor lot
                        // rows) survive the filter switch.
                        let activeFl = li.productVariantsPerFloorLocation.find(fl => fl.floorLocationId == li.floorLocationId);
                        if (!activeFl) {
                            activeFl = {
                                floorLocationId: li.floorLocationId,
                                variant_TId: li.variantId,
                                perFloorLocationActualCount: li.actualCount,
                                perFloorLocationActualCountUnits: li.actualCountUnits
                            };
                            li.productVariantsPerFloorLocation.push(activeFl);
                        }
                        // For lot-tracked variants the per-floor count is
                        // owned by applyLotAllocationsForFloor (sum of
                        // lot rows for this floor); li.actualCount is the
                        // variant-wide sum across all floors and would
                        // overwrite the per-floor invariant if used here.
                        if (!li.trackLots) {
                            activeFl.perFloorLocationActualCount = li.actualCount;
                            activeFl.perFloorLocationActualCountUnits = li.actualCountUnits;
                        }
                        if (this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                            if (li.finalCount != undefined) {
                                li.actualCount = li.finalCount;
                            }
                            if (li.finalCountUnits != undefined) {
                                li.actualCountUnits = li.finalCountUnits;
                            }
                        }
                    }
                });
            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            this.inSaveProcess = true;
            this.busyService.start();
            this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", this.inventoryCount).then((d) => {
                this.dataService.customMethodData(`${this.baseEndPoint}/${d.data.id}`, "GET", null).then((respo) => {
                    this.inventoryCount = respo.data;
                    // Rehydrate host-side computed fields lost in the wholesale
                    // response replace above. lotCountDisplay drives the
                    // lot-tracked Count column and is undefined on raw server
                    // payloads — without this, every filter change collapses
                    // the cell to `(undefined || 0)`. Mirrors the same hydration
                    // selectCount() does on initial load (see line ~1498).
                    if (this.inventoryCount && this.inventoryCount.lineItems) {
                        this.inventoryCount.lineItems.forEach(li => {
                            li.lotCountDisplay = li.trackLots ? this.computeLotCountDisplay(li) : 0;
                            // Same isVariantDeleted derivation as selectCount (WI 124174) —
                            // this wholesale replace loses it otherwise.
                            li.isVariantDeleted =
                                li.productObjectState === Meevo.Model.ObjectStateEnum.Deleted;
                        });
                    }
                });
            }).catch((error) => {

            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
        }

        isMobile(): boolean {
			if (window.innerWidth <= 600) {
				return true;
			} else {
				return false;
			}
		}

        disableSpinners() : boolean {
            return this.isFilterByComplete || [InventoryCountStateEnum.Complete, InventoryCountStateEnum.Deleted].indexOf(this.inventoryCount.state) > -1;
        }

        updateCountDetail(lineItems: any): void {
            lineItems.isAutoSaveEnabled = this.isAutoSaveEnabled;

            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            this.inSaveProcess = true;
            this.busyService.start();
            this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", lineItems).then((d) => {
                this.selectCount(this.inventoryCount);
            }).catch((error) => {
               
            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
         
        };

        mergeInventoryCountLineItem(item: any) {
            var ndx = this.inventoryCount.lineItems.findIndex(x => x.variantId == item.variantId && x.productInventoryType == item.productInventoryType);
            if (ndx === -1) {
                this.inventoryCount.lineItems.push(item);
            }
            else {
                this.inventoryCount.lineItems[ndx] = item;
            }
        }

        checkIfCounted(item: any) {
            console.log('checkIfCounted', item)
            if (this.inventoryCount == null) {
                return;
            }

            if (item.isCounted) {
                if (this.inventoryCount.lineItems != null) {
                    item.isDeleted = false;
                }
                else if (this.inventoryCount.lineItems == null) {
                    this.inventoryCount.lineItems = [];
                }
                this.mergeInventoryCountLineItem(item);
            } 
        }

        prepareInventoryCountForSaving() : void {
            this.inventoryCount.manufacturerIds = this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection;
            this.inventoryCount.distributorIds = this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection;
            this.inventoryCount.productCatIds = this.productCategoryMoverModel.isAllSelected ? [] : this.productCategoryMoverModel.collection;

            this.inventoryCount.productInventoryType = this.productSearchCriteria.productInventoryType;
            this.inventoryCount.floorLocationId = this.productSearchCriteria.floorLocationId;
            if ((this.inventoryCount.id == null || this.inventoryCount.id == Guid.empty)
                && this.productSearchCriteria.id != null
                && this.productSearchCriteria.id != Guid.empty) {
                this.inventoryCount.id = this.productSearchCriteria.id;
            }
        }

        prepareLineItemForSaving(li: Model.InventoryCountLineItems) : Model.InventoryCountLineItems {
            li.startOnHand = li.onHand;
            if (this.productSearchCriteria.floorLocationId == null || this.productSearchCriteria.floorLocationId == Guid.empty) {
                li.isOverride = true;
            }
            else {
                // WI 117621: only sync the active floor's per-floor entry
                // from li.actualCount. Other floors' per-floor counts and
                // lot rows are owned by their own filter sessions and must
                // not be clobbered here, otherwise the SP's parent-child
                // sum validation fails (or per-floor lot rows for other
                // floors get wiped server-side via the variant-aggregate
                // replace path).
                let activeFl = li.productVariantsPerFloorLocation.find(fl => fl.floorLocationId == li.floorLocationId);
                if (!activeFl) {
                    activeFl = {
                        floorLocationId: li.floorLocationId,
                        variant_TId: li.variantId,
                        perFloorLocationActualCount: li.actualCount,
                        perFloorLocationActualCountUnits: li.actualCountUnits
                    };
                    li.productVariantsPerFloorLocation.push(activeFl);
                }
                // Lot-tracked: applyLotAllocationsForFloor already populated
                // perFloorLocationActualCount as the sum of this floor's
                // lot rows; li.actualCount here is the variant-wide sum
                // across all floors, so don't overwrite.
                if (!li.trackLots) {
                    activeFl.perFloorLocationActualCount = li.actualCount;
                    activeFl.perFloorLocationActualCountUnits = li.actualCountUnits;
                }
                if (this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                    if (li.finalCount != undefined) {
                        li.actualCount = li.finalCount;
                    }
                    if (li.finalCountUnits != undefined) {
                        li.actualCountUnits = li.finalCountUnits;
                    }
                }
            }

            if (!li.floorLocationId) {
                Object.keys(this.holdLineItems).forEach(key => {
                    if (key > '0') {
                        var index = this.holdLineItems[key].findIndex((x : LineItems) => x.variantId == li.variantId && x.productInventoryType == li.productInventoryType && x.isCounted);
                        if (index >= 0) { 
                            var item = this.holdLineItems[key][index];
                            item.isDeleted = true;
                            item.isCounted = false;
                            item.actualCount = 0;
                            this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", item).then((data) => {
                                this.holdLineItems[key][index] = item;
                            });
                        }
                    }
                })
            }
            return li;
        }

        //add new
        // onComplete (WI 130400): fires AFTER saveInventoryCountWorker resolves and
        // re-hydrates this.inventoryCount. The barcode scan flow uses it to open the
        // Assign Scanned Lots modal only once the line items reflect the just-saved
        // state — opening synchronously after this call races the async re-hydrate and
        // shows the modal a stale count (missing the variant's real lots).
        // keepScannerOpen (WI 130400): when true, leave the Camera/File upload modal
        // open (and its state intact) instead of hiding it — so the user can keep
        // uploading. The non-lot scan path never closes it; the lot Apply persists via
        // this method, so without the flag it would hide the modal and lose context.
        saveInventoryCount(keepEdittable: boolean = false, fromMobile: boolean = false, onComplete?: () => void, keepScannerOpen: boolean = false): void {
            if (this.inSaveProcess) {
                // WI 130400: a save is already in flight. Callers without an
                // onComplete bail as before. The scan flow opens the Assign Scanned
                // Lots modal ONLY from onComplete, so silently dropping it here would
                // skip the modal if a save is mid-flight (e.g. a brand-new-count
                // autosave creating the id). Defer instead: retry once the in-flight
                // save clears so onComplete still runs.
                //
                // This is a SELF-LIMITING chain, not a queue: each invocation schedules
                // AT MOST ONE retry, and the retry is itself a fresh saveInventoryCount
                // call. A retry that still sees inSaveProcess=true schedules the next
                // one and returns; the FIRST retry that sees inSaveProcess=false is the
                // only one that proceeds to save (and runs onComplete) — there is never
                // more than one pending retry, so onComplete fires exactly once and no
                // extra saves are queued. (Polling the flag rather than chaining onto
                // saveInventoryCountWorker's promise is deliberate: the count-creation
                // save inside handleAutoSave does its own POST and never sets that
                // promise, so a promise-chain would miss the primary case this guards.)
                if (onComplete) {
                    this.$timeout(() => {
                        this.saveInventoryCount(keepEdittable, fromMobile, onComplete, keepScannerOpen);
                    }, 250);
                }
                return;
            }

            // (BEGIN) Check if auto-save has multiple items lined up
            var timers: ng.IPromise<ng.IPromise<any>>[] = [];
            if (this.autoSaveTimers) {
                for (var key in this.autoSaveTimers) {
                    if (this.autoSaveTimers[key].timer) {
                        timers.push(this.autoSaveTimers[key].timer);
                    }
                }
            }
            // if there are auto-saves lined up, wait for those to finish before performing another save
            if (timers.length > 0) {
                this.busyService.start();
                this.$q.all(timers).then((morePromises) => {
                    this.$q.all(morePromises).then(() => {
                        this.saveInventoryCount(keepEdittable, false, onComplete, keepScannerOpen);
                    });
                });
                return;
            }
            // (END) Check if auto-save has multiple items lined up

            this.inSaveProcess = true;
            if (!keepScannerOpen && this.scannerOpened !== 'mobile') {
                this.closeBarcodeScanner();
            }

            this.prepareInventoryCountForSaving();

            if (this.prepareInventoryCountLineItemsForSaving()) {
                this.busyService.stop();
                this.modalService.alert('MESSAGE_INVENTORY_COUNT_FIX_ON_HAND_CONFLICTS_UPON_SAVE', Meevo.Components.Modal.ModalTranslationModes.Translate, true)
                    .then(() => {
                        this.saveInventoryCountWorker(keepEdittable).then(() => {
                            if (onComplete) { onComplete(); }
                        });
                        if (!keepScannerOpen) { this.closeCustomModal(); }
                        if (fromMobile) {
                            this.searchForInventoryCounts(this.openInventoryCountStateEnum);
                            this.controller.viewSwitch('editCount');
                        }
                    });
            }
            else {
                this.saveInventoryCountWorker(keepEdittable).then(() => {
                    if (onComplete) { onComplete(); }
                });
                if (!keepScannerOpen) { this.closeCustomModal(); }
                if (fromMobile) {
                    this.searchForInventoryCounts(this.openInventoryCountStateEnum);
                    this.controller.viewSwitch('editCount');
                }
            }
        }

        saveInventoryCountWorker(keepEditable = false): ng.IPromise<any> {
            this.busyService.start();
            this.clearAllAutoSaveTimers();

            return this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", this.inventoryCount).then((d) => {
                this.inventoryCount = d.data;
                this.productSearchCriteria.id = this.inventoryCount.id;

                if (this.inventoryCount != null && this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                    this.inventoryCount.lineItems.forEach(li => {
                        if (!li.isOverride
                            && li.productVariantsPerFloorLocation != null
                            && li.productVariantsPerFloorLocation.length > 0) {
                            let sumData = (this.productSearchCriteria.floorLocationId && this.productSearchCriteria.floorLocationId != Guid.empty)
                                ? this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation.filter(fl => fl.floorLocationId == this.productSearchCriteria.floorLocationId))
                                : this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation);
                            li.actualCount = sumData.actualCountSum;
                            li.actualCountUnits = sumData.actualCountUnitsSum;
                            li.floorLocationId = this.productSearchCriteria.floorLocationId;
                        }
                        li.totalActualCountDisplay  = this.getTotalActualCount(li);
                        let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                        li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                        // Re-hydrate the Count-column lot total post-save so
                        // the value next to the pencil reflects what the
                        // server now has (matches the same hydration done in
                        // selectCount on initial load).
                        li.lotCountDisplay = li.trackLots ? this.computeLotCountDisplay(li) : 0;
                        // Mirrors selectCount's isVariantDeleted derivation (WI 124174).
                        // Without this, the fresh post-save line items carry the
                        // correct productObjectState but no isVariantDeleted, so the
                        // red strikethrough disappears until the count is reopened.
                        li.isVariantDeleted =
                            li.productObjectState === Meevo.Model.ObjectStateEnum.Deleted;
                    });
                }
                if (this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT')
                    this.isConflict = true;
                else
                    this.isConflict = false;

                this.takeBackup();
                // this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                if (!keepEditable) {
                    this.makeReadonly();
                }

            }).catch((error) => {
                console.log('error saving inventory count', error);
                this.cancel();
                this.selectCount(this.inventoryCount);
            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
        }

        prepareInventoryCountLineItemsForSaving(saveAllItems: boolean = false): boolean {
            let hasOnHandConflict: boolean = false;
            // Floor filter to stamp on each saved line. Per the count UX, clicking
            // Search rebinds the table to the chosen filter — anything edited
            // before that re-search was either already saved or discarded — so
            // the active criteria value is the correct floor scope for every
            // dirty line in this save. Falls through to null in All-Locations
            // mode, which keeps the C# repo on the variant-aggregate path
            // (FloorLocationId == null gates the per-floor TVP block).
            const activeFloorId: any = (this.productSearchCriteria && this.productSearchCriteria.floorLocationId) || null;
            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(item => saveAllItems || item.isDirty || (item.startOnHand != null && item.onHand != item.startOnHand));
                this.inventoryCount.lineItems.forEach(li => {
                    li.isDirty = true;
                    hasOnHandConflict = hasOnHandConflict || (li.startOnHand != null && li.onHand != li.startOnHand);
                    // Stamp the active floor filter onto each line item so the
                    // C# UpdateInventoryCountLineItemAsync per-floor TVP block
                    // (gated on li.FloorLocationId != null) actually fires.
                    // Without this, productSearchCriteria.floorLocationId was
                    // never propagated to the saved payload — only inline
                    // quantity edits via updateProductAndUpdateCount would set
                    // it. WI 117621.
                    li.floorLocationId = activeFloorId;
                    li = this.prepareLineItemForSaving(li);
                });
            }
            return hasOnHandConflict;
        }

        isMiscSupplyCount() : boolean {
            return (this.productSearchCriteria && this.productSearchCriteria.productInventoryType == ProductInventoryTypeEnum.Other)
                || (this.inventoryCount && this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Other);
        }

        getSupplyCatgeoryDesc(supplyTypeEnum: Meevo.Model.SupplyCategoryEnum) : string {
            return this.$translate.instant(Meevo.Model.SUPPLY_CATEGORY_DESCRIPTION[supplyTypeEnum]) || Meevo.Model.SupplyCategoryEnum[supplyTypeEnum];
        }

        mobileRemoveLineItem(selectedLineItem: any) : void {
            if (!this.isStateOpen()) return;
            var swiperInstance = $("#swiper-" + selectedLineItem.entityVersion)[0]["swiper"] || null;
            console.log('remove line item', selectedLineItem, swiperInstance.activeIndex, swiperInstance.activeTabIndex);
            if (!swiperInstance || swiperInstance.activeIndex < 1) return;
            this.removeLineItem(selectedLineItem, swiperInstance);            
        }

        allowSlider(e) : void {
            console.log('allowslier', e)
            if (!this.isStateOpen()) {
                e.stopPropagation();    
            }
        }

        removeLineItem(selectedLineItem: any, swiperInstance: any = null): void {
           
            this.modalService.warning("MESSAGE_DELETE_CONFIRMATION", 0, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            }).then(() => {
                if (swiperInstance) {
                    swiperInstance.slideTo(0);
                }
                if (this.inventoryCount.lineItems != null) {
                    this.inventoryCount.lineItems.forEach(x => {
                        if (x.variantId == selectedLineItem.variantId
                            && x.productInventoryType == selectedLineItem.productInventoryType) {
                            x.isDeleted = true;
                            x.isCounted = false;
                            x.isDirty = true;
                            this.product = x;
                        }
                    });
                    this.handleAutoSave(this.product, true);
                    this.highlightId = null;
                }
            }).catch((e) => {
                if (swiperInstance) {
                    swiperInstance.slideTo(0);
                }
            });
            
        }

        commitCount(): ng.IPromise<any> {
            var scope = this;

            this.confirmationMessage = "Count Saved!";
            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                return this.modalService.warning("MESSAGE_INVENTORY_COUNT_CONFIRM_COMMIT", ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((data) => {
                        var forceCommit = (this.inventoryCount != null && this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT');
                        if (this.inventoryCount != null && this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                                this.inventoryCount.lineItems.forEach(variant => {
                                    if (!variant.isOverride && variant.productVariantsPerFloorLocation != null && variant.productVariantsPerFloorLocation.length > 0) {
                                        let sumData = this.sumFloorLocationActualCount(variant.productVariantsPerFloorLocation);
                                        variant.actualCount = sumData.actualCountSum;
                                        variant.actualCountUnits = sumData.actualCountUnitsSum;
                                    }
                                });
                            }
                        }

                        if (this.inSaveProcess || this.inAutoSaveProcess)
                            return;
                        this.inSaveProcess = true;
                        this.busyService.start();

                        return this.dataService.customMethodData(`${this.baseEndPoint}/Commit`, "PUT", { forceCommit: forceCommit, ...this.inventoryCount})
                            .then((response): ng.IPromise<any> => {
                                if (!response.data) {
                                    this.busyService.stop();
                                    return this.modalService.alert("MESSAGE_INVENTORY_COUNT_NO_RESPONSE_ERROR");
                                }
                                else if (response.data.errorMessage) {
                                    this.busyService.stop();
                                    return this.modalService.alert(response.data.errorMessage);
                                }
                                else if (response.data.isAllInConflict) {
                                    this.selectCount(response.data.inventoryCount);
                                    this.busyService.stop();
                                    var msg = this.$translate.instant("MESSAGE_INVENTORY_COUNT_ALL_IN_CONFLICT", { newDisplayName: response.data.inventoryCount.displayName })
                                    return this.modalService.alert(msg);
                                }
                                else if (response.data.conflictId != null && response.data.conflictId != Guid.empty) {
                                    var count: Meevo.Model.InventoryCount;
                                    count = {
                                        id: response.data.conflictId,
                                        displayName: "",
                                        dateCreated: null,
                                        dateUpdated: null,
                                        entityVersion: 0,
                                        productInventoryType: null,
                                        lineItems: null,
                                        state: null,
                                        userName: "",
                                        iscounted: null,
                                        inventoryCountOnly: false,
                                        orderItemsBy: this.inventoryCount.orderItemsBy,
                                        distributorIds: [],
                                        manufacturerIds: [],
                                        productCatIds: []
                                    };
                                    this.selectCount(count);
                                    this.busyService.stop();
                                    return this.modalService
                                        .alert("MESSAGE_INVENTORY_COUNT_COMMITTED_WITH_CONFLICT", ModalTranslationModes.Translate)
                                        .then(() => {
                                            this.makeReadonly();
                                            this.controller.viewSwitch('actionConfirmation');
                                            this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                                            this.$timeout(() => { $("#inventoryCountSearch").click(); }, 1);
                                        });
                                }
                                else {
                                    this.inventoryCount = response.data.inventoryCount;
                                    // Clear the floor filter on commit completion so the
                                    // committed-count view shows variant totals across all
                                    // floors. Without this, lot-tracked variants render
                                    // their per-floor count (computeLotCountDisplay reads
                                    // productSearchCriteria.floorLocationId), while non-lot
                                    // variants already show the variant total — the server
                                    // returns variant.ActualCount un-filtered because
                                    // this.inventoryCount.floorLocationId is null on the
                                    // commit POST. Clearing the filter makes the lot row
                                    // and the modal-on-pencil-click both show all-floor
                                    // data, matching the non-lot behavior and the state
                                    // the user gets when navigating away and back.
                                    if (this.productSearchCriteria) {
                                        this.productSearchCriteria.floorLocationId = null;
                                    }
                                    this.floorLocationId = null;
                                    this.selectedFloorLocation = null;
                                    // calculate the totalActualCountDisplay
                                    if (this.inventoryCount != null && this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                                        this.inventoryCount.lineItems.forEach(li => {
                                            li.totalActualCountDisplay = this.getTotalActualCount(li);
                                            let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                                            li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                                            // Hydrate the Count-column lot total — same pattern as
                                            // selectCount and saveInventoryCountWorker. Filter
                                            // was cleared above so this resolves to the
                                            // variant-aggregate (item.lots) sum.
                                            li.lotCountDisplay = li.trackLots ? this.computeLotCountDisplay(li) : 0;
                                            li.isVariantDeleted =
                                                li.productObjectState === Meevo.Model.ObjectStateEnum.Deleted;
                                        });
                                    }
                                    this.makeReadonly();
                                    this.controller.viewSwitch('actionConfirmation');
                                    this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                                    this.$timeout(() => { $("#inventoryCountSearch").click(); }, 1);
                                }
                            }).catch((error) => {

                            }).finally(() => {
                                this.busyService.stop();
                                this.inSaveProcess = false;
                                this.isDirty = false;
                            });
                    });
            }
        }

        makeReadonly() : void {
            this.mode = MaintenanceFormState.Readonly;
        }
        
        mobileSave() : void {
            this.makeReadonly();
            this.addExpanded = false;
            this.closeBarcodeScanner();
            this.controller.viewSwitch('action');
        }

        isInventoryCountDetailEmpty(): boolean {
            if (this.inventoryCount != null &&
                this.inventoryCount.lineItems != null &&
                this.inventoryCount.lineItems.filter(x => x.isCounted).length > 0)
                return false;
            else
                return true;
        }

        deleteCount(): void {
            this.prepareInventoryCountLineItemsForSaving(true);
            var scope = this;            
            scope.confirmationMessage = "Count Deleted!";
            this.modalService.warning("Are you sure you want to delete this count?", 0, false, {
                showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES'
            }).then((data) => {
                this.inventoryCount.state = InventoryCountStateEnum.Deleted;
                if (this.inSaveProcess || this.inAutoSaveProcess)
                    return;
                this.inSaveProcess = true;
                this.busyService.start();
                this.dataService.customMethodData(`${this.baseEndPoint}`, "PUT", this.inventoryCount).then((d) => {
                    scope.controller.viewSwitch('actionConfirmation');
                    this.searchForInventoryCounts(InventoryCountStateEnum.Open); // Mobile Version Search
                    // this.mode = MaintenanceFormState.Readonly;
                    this.searchScreen = true;
                    this.$timeout(() => {
                        $("#inventoryCountSearch").click(); // Desktop Version Search
                    }, 1);
                }).catch((error) => {

                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                    this.isDirty = false;
                });
            });
        }

        sumTotalItems(): number {
            let sum = 0;
            if (this.products != null) {
                for (let i = 0; i < this.products.length; i++) {
                    sum += this.products[i].actualCount;
                }
            }
            return sum;
        }

        setProduct(prod: any) {
            if (prod.startOnHand == null || prod.onHand == null) {
                if (prod.productVariant) {
                    this.product = prod.productVariant;
                } else {
                    this.product = prod;
                }
            } else {
                this.product = prod;
            }
        }

        returnTextEnumValue(productInventoryType: ProductInventoryTypeEnum): string {
            if (productInventoryType == ProductInventoryTypeEnum.Retail)
                return "Retail";
            else if (productInventoryType == ProductInventoryTypeEnum.ShopSupply)
                return "Wholesale";
            else {
                return "Retail Or Wholesale";
            }
        }

        isNullOrEmpty(object: any): boolean {
            return Boolean(object);
        }

        returnConcatinatedName(item: any): string {
            if (item.displayName != null && item.displayName.length != null && item.displayName.length > 0) {
                let concatdisplayName = "";
                for (let i = 0; i < item.displayName.length; i++) {
                    if (i + 1 < item.displayName.length)
                        concatdisplayName += item.displayName[i] + " / ";
                    else {
                        concatdisplayName += item.displayName[i];
                    }
                }
                return concatdisplayName;
            }
            return "";
        }

        returnAttributeConcatinatedName(attributes: any): string {
            if (attributes != null && attributes.length != null && attributes.length > 0) {
                let concatdisplayName = "";
                for (let i = 0; i < attributes.length; i++) {
                    for (let j = 0; j < attributes[i].displayName.length; j++) {
                        if (j + 1 < attributes[i].displayName.length || i + 1 < attributes.length)
                            concatdisplayName += attributes[i].displayName[j] + " / ";
                        else {
                            concatdisplayName += attributes[i].displayName[j];
                        }
                    }
                }
                return concatdisplayName;
            }
            return "";
        }

        validateBarCode(filter, floorLocation): void {
            if (filter && floorLocation) {
                let criteria = {
                    criteria: {
                        productObjectState: Meevo.Model.ObjectStateEnum.Active,
                        productInventoryType: this.inventoryCount.productInventoryType,
                        variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                        isInventoryTrackable: true,
                        floorLocationId: floorLocation,
                        filter: filter,
                        id: this.inventoryCount.id,
                        inventoryCountOnly: this.inventoryCount.inventoryCountOnly,
                        iscounted: this.inventoryCount.iscounted
                    }
                };

                if (!this.includeDiscontinued) {
                    criteria.criteria.variantObjectState = [Meevo.Model.ObjectStateEnum.Active];
                }

                this.dataService.customMethodData(`${this.baseEndPoint}/ProductVariant/ValidateBarCode`, "POST", criteria);
            }
        }

        changeFilter(): void {
            this.recentlyChangedNumber += 1;
            this.recentlyChangedVariableAttribute = "recentlyChanged" + this.recentlyChangedNumber;
        }
        absoluteValue(val): number {
            return Math.abs(val);
        }

        showItemForRecentChanges(item): boolean {
            if (item[this.recentlyChangedVariableAttribute] == 1)
                return true;
            else
                return false;
        }

        setRecentlyChanged(item): void {
            if (item != null) {
                item.isDirty = true;
                item[this.recentlyChangedVariableAttribute] = (item.isCounted) ? 1 : 0;
            }
            this.isDirty = true;
        }

        getProductTotals(whichOne: string): number {
            if (!this.inventoryCount || !this.inventoryCount.lineItems || this.inventoryCount.lineItems.filter(item => item && item.isCounted && !item.isDeleted).length === 0) return 0;
            var returnVal = 0;
            switch (whichOne) {
                case 'items':
                    returnVal = this.inventoryCount.lineItems
                        .filter(item => item.isCounted && !item.isDeleted)
                        .map(item => item.actualCount)
                        .reduce((prev, next) => prev + next);
                    break;
                case 'products':
                    returnVal = this.inventoryCount.lineItems
                        .filter(item => item.isCounted && !item.isDeleted)
                        .length;
                    break;
            }
            return returnVal;
        }

        onCountChanged(item): void {
            if (!this.isStateOpen()) return;

            if (!this.isEditing()) {
                this.mode = MaintenanceFormState.Editing;
            }

            if (!item) {
                return;
            }

            if (item.actualCount > 0) {
                this.product = item;
                item.isCounted = true;
            }

            item.totalActualCountDisplay = this.getTotalActualCount(item);

            this.checkIfCounted(item);
            this.setRecentlyChanged(item);

            item.gainLoss = this.gainLossValue(item);

            this.handleAutoSave(item);
        }        

        handleAutoSave(item, checkboxClicked = false) {
            if (!this.isAutoSaveEnabled || !this.isStateOpen()) return;
            if (!this.inventoryCount.id) {
                // Save new Inventory Count since there's no ID yet
                if (this.inSaveProcess || this.inAutoSaveProcess) {
                    //if we are still in the process of fetching initial inventory count id sleep before processing more autosaves to prevent unwanted empty counts created
                    this.$timeout(() => {
                        this.handleAutoSave(item, checkboxClicked);
                    }, 1000)
                    return;
                }
                this.prepareInventoryCountForSaving();
                var dataToPost = angular.copy(this.inventoryCount);
                dataToPost.lineItems = [];
                this.inSaveProcess = true;
                this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", dataToPost).then((d) => {
                    if (!d || !d.data) return;
                    this.inSaveProcess = false;
                    var holdLineItems = this.inventoryCount.lineItems;
                    this.inventoryCount = d.data;
                    this.inventoryCount.floorLocationId = item.floorLocationId;
                    this.inventoryCount.lineItems = holdLineItems;
                    this.productSearchCriteria.id = this.inventoryCount.id;
                    this.setAutoSaveInfo(item, checkboxClicked);
                });
            }
            else {
                this.setAutoSaveInfo(item, checkboxClicked);
            }
            
        }

        clearAllAutoSaveTimers() {
            for (var item in this.autoSaveTimers) {
                if (this.autoSaveTimers[item].timer) {
                    this.$timeout.cancel(this.autoSaveTimers[item].timer);
                }
            };
        }

        private generateAutoSaveKey(item: LineItems) {
            return item[autoSaveKeyPrimary] + item[autoSaveKeySecondary];
        }

        setAutoSaveInfo(item, checkboxClicked) {
            if (!this.isAutoSaveEnabled) return;
            var key = this.generateAutoSaveKey(item);
            if (!this.autoSaveTimers[key]) {
                this.autoSaveTimers[key] = {};
            }

            // only process if different or checkbox or delete icon used
            if (item.actualCount === item.finalCount && item.actualCountUnits === item.finalCountUnits && !checkboxClicked) {
                if (this.autoSaveTimers[key].timer) {
                    this.$timeout.cancel(this.autoSaveTimers[key].timer);
                    delete this.autoSaveTimers[key];
                }
                return;
            }
            else {
                this.autoSaveTimers[key].lineItem = this.getLineItem(item);
            }
            
            if (this.autoSaveTimers[key].timer) {
                // item changed again, cancel old timer
                this.$timeout.cancel(this.autoSaveTimers[key].timer);
            } 
            
            this.autoSaveTimers[key].timer = this.$timeout(() => {
                this.inAutoSaveProcess = true;
                // Use the lineItem captured at setAutoSaveInfo time (above) —
                // NOT a fresh getLineItem(...) call. getLineItem reads
                // productSearchCriteria.floorLocationId, which the user can
                // change between modal Apply and the debounce firing. A fresh
                // call here would route the autosave to whatever floor is
                // active NOW, even though applyLotAllocationsForFloor stamped
                // the line item's per-floor data on a DIFFERENT floor. That
                // sends the wrong-floor data to the per-floor save SP, which
                // either drops the user's allocations entirely (when target
                // floor has no per-floor entry) or writes them to the wrong
                // bucket — and at commit, Detail.ActualCount is re-derived
                // from a stale per-floor sum and triggers a spurious
                // on-hand-drift conflict.
                var promise = this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", this.autoSaveTimers[key].lineItem).then((d) => {
                    this.showAutoSaveSuccessful = true;
                    this.inventoryCount.lineItems.forEach(x => {
                        if (this.generateAutoSaveKey(x) === key) {
                            // update so we can detect changes to this moving forward
                            x.finalCount = x.actualCount;
                            x.finalCountUnits = x.actualCountUnits;
                            x.isDirty = false;
                            if (x.onHand != x.startOnHand) {
                                x.startOnHand = x.onHand;
                            }
                        }
                    });
                    this.$timeout(() => {
                        this.showAutoSaveSuccessful = false;
                    }, 1500);
                }).catch((e) => {
                    console.error('auto saved failed count: ' + this.inventoryCount.id, e);
                    this.cancel();
                    return this.selectCount(this.inventoryCount);
                }).finally(() => {
                    this.inAutoSaveProcess = false;
                    this.isDirty = false;
                });
                delete this.autoSaveTimers[key];
                return promise;
            }, autoSaveDelay);
        }

        checkCountedFilter(item): boolean {
            return (typeof this.inventoryCount.iscounted === 'boolean') ? item.isCounted === this.inventoryCount.iscounted : true;
        }

        setStartOnHand() {
            this.inventoryCount.lineItems.map(x => x.startOnHand = x.onHand);
        }

        totalOnhand(): number {
            var sum = 0;
            let decimalPrecision: number = null;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {
                    decimalPrecision = decimalPrecision || lI.decimalPrecision;
                    let onHandValue = lI.startOnHand == null ? (lI.onHand || 0) : lI.startOnHand;
                    sum = this.roundingService.add(sum, onHandValue, decimalPrecision);
                });
            }
            this.inventoryCount.decimalPrecision = decimalPrecision;
            var onHandRule = this.$filter('inventoryOnHandRule') as any;
            return onHandRule(sum);
        }
        totalCount(): number {
            var sum = 0;
            let decimalPrecision: number = null;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {
                    decimalPrecision = decimalPrecision || lI.decimalPrecision;
                    sum = this.roundingService.add(sum, (lI.totalActualCountDisplay || 0), decimalPrecision);
                });
            }
            this.inventoryCount.decimalPrecision = decimalPrecision;
            return sum;
        }
        totalGainLoss(): number {
            var sum = 0;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach(lI => {
                    sum = this.roundingService.add(sum, this.gainLossValue(lI));
                });
            }
            return sum;
        }

        totalUnitsDisplay(isOnHand?: boolean): number {
            var sum = 0;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {

                    if (isOnHand) {
                        let onHandValue = lI.startOnHand == null ? (lI.onHand || 0) : lI.startOnHand;
                        var unit = this.roundingService.multiply(onHandValue, lI.unitOfMeasureQuantity)
                    } else {
                        var unit = this.roundingService.multiply(lI.totalActualCountDisplay, lI.unitOfMeasureQuantity)
                    }
                    sum = this.roundingService.add(sum, (unit || 0));
                });
            }
            return sum;
        }

        onSearch(index: number, products: any, context: any): void {
            context.inventoryCount.orderItemsBy = context.inventoryCountOrder = context.inventoryCountSortOption.fieldName;
        }

        slideClick() : void {
            if (this.isStateOpen()) {
                this.edit();
            }
        }
        
        toggleCount(item) {
            this.checkIfCounted(item);
            this.setRecentlyChanged(item);
            item.isDirty = this.isDirty = true;
            this.product = item;
            if (this.isAutoSaveEnabled) {
                this.handleAutoSave(item, true);
            }
        }

        showMessageToSaveFirst() {
            this.modalService.warning("MESSAGE_INV_COUNT_NEED_TO_SAVE_LIST", Components.Modal.ModalTranslationModes.Translate);
        }

        showSidebar = () => {

            setTimeout(() => {
                this.$mdSidenav('inventoryCountSidenav').open();
            }, 0);

        }
        hideSidebar = () => {
            this.$mdSidenav('inventoryCountSidenav').close();
        }

        showNotCountedSinceUpdated() {
            if (!this.productSearchCriteria.chkShowNotCountedSince) {
                this.productSearchCriteria.showProdNotCntSince = null;
            }
        }

        gainLossValue(item: LineItems) {
            var onHand: number = (item.startOnHand == 0) ? 0 : (item.startOnHand || item.onHand);
            var totalActualValue: number = this.getTotalActualCount(item);
            totalActualValue = (item.startOnHand === null) ? (totalActualValue || onHand) : totalActualValue;
            return this.roundingService.subtract(this.roundingService.multiply(item.wholeSale, totalActualValue), this.roundingService.multiply(item.wholeSale, onHand)) || 0;
        }

        // -------------------------------------------------------------------
        // FA4 (WIs 121105 / 121227 / 121230) — lot-tracking helpers
        // -------------------------------------------------------------------
        //
        // The grid's Count column branches on `count.trackLots`:
        //   - lot-tracked rows render a pencil that calls openLotModal(item),
        //     and `lotCountDisplay` is shown next to it.
        //   - non-lot-tracked rows keep the existing spinner / partial-pencil.
        //
        // These helpers are no-ops when item.trackLots is false, so they can
        // be invoked unconditionally from the template.

        /**
         * Determines pencil state for the Count column's lot pencil.
         *   purple-active      — lot-tracked, no counts entered yet
         *   purple-with-count  — lot-tracked, at least one lot has a count
         *   gray-committed     — count is committed (header in Complete state)
         *   null               — variant is not lot-tracked (no lot pencil rendered)
         */
        public getLotPencilState(item: any): 'purple-active' | 'purple-with-count' | 'gray-committed' | null {
            if (!item || !item.trackLots) return null;
            if (this.inventoryCount && this.inventoryCount.state === InventoryCountStateEnum.Complete) {
                return 'gray-committed';
            }
            const lots = (item.lots || []) as any[];
            const hasCount = lots.some(l => l && l.isCounted);
            return hasCount ? 'purple-with-count' : 'purple-active';
        }

        /** CSS class for the Count-column lot icon, recomputed each digest.
         *  Both editable-state pencils (purple-*) AND committed-state eye
         *  icons render as `icon-purple` so the icon stays visible after
         *  the count is finalized — the visual cue for committed vs.
         *  editable is the icon shape (eyeball vs. pencil), not the color.
         *  The CSS class name still reads "purple" because the color hasn't
         *  changed; the legacy `icon-gray` branch is no longer reachable. */
        public getLotPencilClass(item: any): 'icon-purple' | '' {
            const s = this.getLotPencilState(item);
            if (s === null) return '';
            return 'icon-purple';
        }

        /** SVG asset path for the Count-column lot icon. Eye icon when the
         *  count is committed (modal opens read-only), pencil otherwise. */
        public getLotIconAsset(item: any): string {
            return this.getLotPencilState(item) === 'gray-committed'
                ? 'assets/images/icons/eyeball.svg'
                : 'assets/images/icons/circle_edit.svg';
        }

        /** Translation key for the lot icon's tooltip + aria-label. The key
         *  swaps from "Edit lots" to "View lots" once the count is committed,
         *  matching the icon shape (pencil → eye). */
        public getLotIconLabel(item: any): string {
            return this.getLotPencilState(item) === 'gray-committed'
                ? 'LABEL_VIEW_LOTS'
                : 'LABEL_EDIT_LOTS';
        }

        /**
         * Whether the lot pencil should accept clicks. The pencil is gated on
         * the form's edit state — opening the editable lot modal before the
         * inventory count itself has been put into Adding/Editing mode lets a
         * user mutate lot data on a row whose count column isn't editable
         * yet, which is the bug this guards against. Committed counts
         * ('gray-committed') stay clickable so the read-only lot view remains
         * accessible after the count is finalized.
         */
        public isLotPencilClickable(item: any): boolean {
            if (!item || !item.trackLots) return false;
            if (this.getLotPencilState(item) === 'gray-committed') return true;
            return this.isAdding() || this.isEditing();
        }

        /**
         * Sum of all lot counts for the Count-column display.
         * Each Contains: actualCount + (actualCountUnits / unitOfMeasureQuantity), 4dp.
         * Whole-unit:    actualCount only, integer.
         *
         * Filter-aware: when a floor filter is active, sums the per-floor lot
         * rows for that floor (productVariantsPerFloorLocation[i].lots) so the
         * cell shows the floor-scoped count. With no filter, sums the
         * variant-aggregate lots (item.lots) for the cross-floor total.
         * Source pattern mirrors openLotModal's lot-collection picker.
         */
        public computeLotCountDisplay(item: any): number {
            if (!item || !item.trackLots) return 0;

            const activeFloorId: any = (this.productSearchCriteria
                                        && this.productSearchCriteria.floorLocationId
                                        && this.productSearchCriteria.floorLocationId !== Guid.empty)
                ? this.productSearchCriteria.floorLocationId
                : null;

            let sourceLots: any[];
            if (activeFloorId) {
                const perFloor = ((item.productVariantsPerFloorLocation as any[]) || [])
                    .find((fl: any) => fl && fl.floorLocationId === activeFloorId);
                sourceLots = (perFloor && (perFloor.lots as any[])) || [];
            } else {
                sourceLots = (item.lots as any[]) || [];
            }

            if (!sourceLots || sourceLots.length === 0) return 0;

            const ec = this.isProductUsageEnabled(item);
            let total = 0;
            for (const lot of sourceLots) {
                if (!lot) continue;
                if (ec) {
                    const uom = item.unitOfMeasureQuantity || 1;
                    total += (lot.actualCount || 0) + ((lot.actualCountUnits || 0) / uom);
                } else {
                    total += (lot.actualCount || 0);
                }
            }
            return total;
        }

        /**
         * Open the lot modal for the given line item.
         *   editable — count header is open
         *   readonly — count is committed (Complete)
         *
         * For Each Contains variants we regenerate ONE whole row + ONE partial
         * row from the lot's aggregate totals. Per-row breakdown isn't
         * persisted (per-lot rollup decision); the user can split into
         * multiple rows during this session via "+ Add another row" inside
         * the modal, and that breakdown collapses on save again.
         */
        public openLotModal(item: any): void {
            if (!this.lotBridge) return;
            // Hydrate item.lots from the variant-level on-hand source before
            // building the modal allocations. The Resume SP that normally
            // populates item.lots only knows about variants already in
            // InventoryCountDetail_L — for a fresh count where the variant
            // was added via search but never saved, that table is empty and
            // item.lots arrives empty. Without this fetch the modal would
            // open blank for a new lot-tracked variant even though the
            // variant has live on-hand lots the user could count.
            //
            // Always fetch on open (not just when item.lots is empty) so
            // freshly-arrived lots that landed since the count was last
            // loaded also surface. The /VariantLot/OnHand/ByVariant endpoint
            // returns every variant lot with on-hand > 0 for the given
            // variants; mergeVariantLotOnHand preserves any existing count
            // state on item.lots and only fills gaps + refreshes
            // currentOnHand from the live source.
            //
            // Must hit /ByVariant (not the bare /OnHand endpoint) — the
            // by-lot URL takes specific (variantLotId, productInventoryType)
            // pairs as input, which we don't have at modal-open time. The
            // by-variant URL takes (variantId, productInventoryType) and
            // returns every on-hand lot for that variant, which is what the
            // modal needs to surface for the user to count.
            //
            // Lot-tracked variants only — non-lot variants don't go through
            // this modal, but defensive guard keeps the call sane.
            if (!item || !item.trackLots) {
                this.openLotModalForBuiltItem(item);
                return;
            }
            const variantOnHandRequest = {
                variants: [{
                    variantId: item.variantId,
                    productInventoryType: item.productInventoryType,
                }],
            };
            this.busyService.start();
            this.dataService.customMethodData(
                `${this.appSettings.API_ROOT}/Inventory/VariantLot/OnHand/ByVariant`,
                'POST',
                variantOnHandRequest,
            ).then((response: any) => {
                this.mergeVariantLotOnHand(item, (response && response.data) || []);
            }).catch(() => {
                // Non-fatal: a network/auth failure here shouldn't block the
                // modal. Fall through to open with whatever item.lots had —
                // typeahead/Add lot is still available if needed.
            }).finally(() => {
                this.busyService.stop();
                this.openLotModalForBuiltItem(item);
            });
        }

        /**
         * Merges variant-level on-hand lot rows (from /Inventory/VariantLot/OnHand/ByVariant)
         * into item.lots, preserving any existing count state on already-known
         * lots (so a user-entered count or _pending flag isn't clobbered) and
         * inserting fresh zero-count rows for variant lots not yet in item.lots.
         */
        private mergeVariantLotOnHand(item: any, onHandLots: any[]): void {
            if (!item.lots) item.lots = [];
            // WI 130400: the variant on-hand response (VariantLotOnHand) carries the
            // each-contains divisor (unitOfMeasureQuantity). The barcode scan result
            // does NOT include it, so a scanned partial-usage variant arrives with it
            // undefined — which makes the modal's composite total (whole + partial /
            // uom) NaN and blocks the server from persisting the usage line. Capture
            // it here (variant-level, so any lot row carries the same value) when the
            // item doesn't already have it.
            if (item.unitOfMeasureQuantity == null && onHandLots) {
                for (let u = 0; u < onHandLots.length; u++) {
                    if (onHandLots[u] && onHandLots[u].unitOfMeasureQuantity != null) {
                        item.unitOfMeasureQuantity = onHandLots[u].unitOfMeasureQuantity;
                        break;
                    }
                }
            }
            const lotsArray: any[] = item.lots as any[];
            for (let i = 0; i < onHandLots.length; i++) {
                const oh = onHandLots[i];
                if (!oh || !oh.variantLot_TId) continue;
                const existing = lotsArray.find((l: any) => l && l.variantLot_TId === oh.variantLot_TId);
                if (existing) {
                    // Refresh currentOnHand from the live source; preserve
                    // count / pending state on the existing row.
                    if (oh.onHand != null) {
                        existing.currentOnHand = oh.onHand;
                    }
                    // Backfill startOnHand when the existing row arrived
                    // without one. The server's Resume SP returns
                    // StartOnHand=NULL for any lot that's in the variant's
                    // live on-hand UDF but not yet in this count's
                    // InventoryCountDetail_Lot_L (FULL OUTER JOIN of UDF
                    // and DetailLot). Without this backfill, those rows
                    // ship to C# with StartOnHand=null, fall through to
                    // the 0m default, persist DetailLot.StartOnHand=0,
                    // and at commit the SP detects EndOnHand=currentOnHand
                    // <> StartOnHand=0 → spurious lot-level drift conflict.
                    // Capture the on-hand at the moment the lot is first
                    // surfaced into the count as its StartOnHand.
                    if ((existing.startOnHand == null) && oh.onHand != null) {
                        existing.startOnHand = oh.onHand;
                    }
                    if (!existing.lotNumber && oh.lotNumber) existing.lotNumber = oh.lotNumber;
                    if (!existing.expirationDate && oh.expirationDate) existing.expirationDate = oh.expirationDate;
                } else {
                    // Variant lot not yet on item.lots (the count never had
                    // a DetailLot row for it). Add as a server-known
                    // (_pending=false) zero-count row so the modal surfaces
                    // it for assignment / counting.
                    //
                    // Capture currentOnHand as startOnHand. Without this,
                    // the lot's DetailLot row gets persisted with
                    // StartOnHand=0 (C# fallback for null), and at commit the
                    // SP compares EndOnHand (live currentOnHand) to
                    // StartOnHand and detects spurious drift — every fetched
                    // lot looks like "lot received during count" and gets
                    // pulled into a conflict count. The right StartOnHand
                    // for a lot first surfaced into a count is its on-hand
                    // at that moment (= currentOnHand). Newly-typed lots via
                    // the typeahead still get startOnHand=null → 0 in C#
                    // (they didn't exist before, so 0 is correct).
                    const seedOnHand: number = oh.onHand != null ? oh.onHand : 0;
                    lotsArray.push({
                        variantLot_TId: oh.variantLot_TId,
                        lotNumber: oh.lotNumber,
                        expirationDate: oh.expirationDate,
                        _pending: false,
                        startOnHand: seedOnHand,
                        endOnHand: null,
                        currentOnHand: seedOnHand,
                        actualCount: 0,
                        actualCountUnits: null,
                        isCounted: false,
                    });
                }
            }
        }

        private openLotModalForBuiltItem(item: any): void {
            if (!this.lotBridge) return;
            const mode: 'editable' | 'readonly' =
                this.getLotPencilState(item) === 'gray-committed' ? 'readonly' : 'editable';
            const lineItemInput = this.buildLotModalInput(item);

            // WI 117621: floor scope for the existing-allocations projection.
            // `||` instead of `??` because the host shell's TS toolchain is
            // pre-3.7 (no nullish-coalescing). floorLocationId is either a
            // non-empty Guid string or null/undefined, so `||` is safe — empty
            // string isn't a valid value here.
            const activeFloorId: string | null = lineItemInput.floorLocationId || null;

            const existingAllocations: Meevo.Plugins.InventoryCount.IInventoryCountAllocation[] =
                this.buildExistingAllocations(item, activeFloorId);

            this.lotBridge.open(
                lineItemInput,
                existingAllocations,
                mode,
                (allocations) => this.applyLotAllocations(item, allocations),
                () => { /* cancel — no state change */ },
                this.isHideOnHand,
            );
        }

        /**
         * WI 117621 / WI 130400: build the existing-allocations projection for a
         * line item, scoped to an explicit floor (null = variant-aggregate). The
         * floor scope is passed in by the caller (a snapshot) rather than re-read
         * from productSearchCriteria so the scan-driven batch flow can hydrate and
         * project several variants against a single floor snapshot captured at
         * open time.
         */
        // includeUncountedOnHand (WI 130400): when true (grid-pencil edit/view), a
        // lot with variant-level on-hand != 0 is surfaced even if it was never
        // counted in this count — that modal is the hub for assigning unallocated
        // lots and commit requires every on-hand lot acknowledged. The barcode-scan
        // modal passes FALSE: there the user only wants the lots actually assigned in
        // THIS count (isCounted, or a non-zero actual count) seeded as cards, not
        // every lot that happens to have on-hand stock.
        private buildExistingAllocations(
            item: any,
            activeFloorId: string | null,
            includeUncountedOnHand: boolean = true,
        ): Meevo.Plugins.InventoryCount.IInventoryCountAllocation[] {
            const isEC = this.isProductUsageEnabled(item);
            const isConflict: boolean = !!this.isConflict;

            // WI 117621: source the lot LIST from item.lots (variant-aggregate)
            // in every mode so the modal surfaces every lot the variant has —
            // including those with variant-level on-hand != 0 (positive OR
            // negative — negative is a data-quality signal the user still
            // needs to see in the count) that aren't yet assigned to the
            // active floor. The user can then assign one of those lots to
            // this floor by entering a non-zero count.
            //
            // For floor-scoped mode, count fields (actualCount, actualCountUnits,
            // isCounted) are projected by VariantLot_TId lookup against the
            // active floor's per-floor lot rows; lots without a per-floor entry
            // default to 0/false (they're surfaceable but not yet allocated to
            // this floor). On-hand is always sourced from the variant-aggregate
            // — per-floor on-hand isn't tracked. The label disambiguator
            // (modal-side computed: "Total variant on hand" vs "On hand")
            // makes the cross-floor nature of the number explicit.
            const sourceLots: any[] = (item.lots as any[]) || [];

            // Build a VariantLot_TId → per-floor lot lookup once when floor-
            // scoped. Plain object instead of Map<> to stay compatible with
            // the host shell's pre-ES6 TS toolchain. Empty when no filter.
            const perFloorLotsById: { [id: string]: any } = {};
            if (activeFloorId) {
                const perFloor = ((item.productVariantsPerFloorLocation as any[]) || [])
                    .find((fl: any) => fl && fl.floorLocationId === activeFloorId);
                const perFloorLots = (perFloor && (perFloor.lots as any[])) || [];
                for (let i = 0; i < perFloorLots.length; i++) {
                    const pfl = perFloorLots[i];
                    if (pfl && pfl.variantLot_TId) {
                        perFloorLotsById[pfl.variantLot_TId] = pfl;
                    }
                }
            }

            return sourceLots
                    .filter((l: any) => {
                        // Conflict counts always include every lot so
                        // auto-pulled "new in conflict" rows (IsCounted=
                        // false, ActualCount=null) still render with the
                        // WI 121230 ⚠ indicator. Filtering them here
                        // would hide exactly the rows the user needs to
                        // see.
                        if (isConflict) return true;
                        // Non-conflict edit/view: surface every lot that
                        // either (a) is counted on this scope, (b) carries
                        // a non-zero count on this scope, or (c) has
                        // variant-level live on-hand != 0. Clause (c) keeps
                        // the modal a single hub for assigning unallocated
                        // lots to a floor (the user can see what's
                        // available across the whole variant) and also
                        // makes commit work for lot-tracked variants:
                        // any on-hand!=0 lot the user hasn't acknowledged
                        // would otherwise flip parent.IsCounted to false
                        // and the commit SP throws. Surfacing those lots
                        // at count=0 + Apply marks them isCounted=true.
                        // != 0 (not > 0) so negative on-hand also surfaces
                        // — it's a data-quality signal the user needs to
                        // see and correct via the count.
                        //
                        // Floor-scoped mode reads count/isCounted from
                        // the per-floor lot lookup (count==0 / false for
                        // lots not yet on this floor); on-hand stays
                        // variant-level. Non-floor mode reads from the
                        // variant-aggregate row directly.
                        const perFloorLot = activeFloorId ? perFloorLotsById[l.variantLot_TId] : null;
                        const isCounted = activeFloorId
                            ? (perFloorLot ? !!perFloorLot.isCounted : false)
                            : !!l.isCounted;
                        if (isCounted) return true;
                        if (includeUncountedOnHand && (l.currentOnHand || 0) !== 0) return true;
                        const ac = activeFloorId
                            ? (perFloorLot ? perFloorLot.actualCount : 0)
                            : l.actualCount;
                        const acu = activeFloorId
                            ? (perFloorLot ? perFloorLot.actualCountUnits : 0)
                            : l.actualCountUnits;
                        const isZero = isEC
                            ? ((ac || 0) === 0 && (acu || 0) === 0)
                            : ((ac || 0) === 0);
                        return !isZero;
                    })
                    .map((l: any) => {
                    // Per-lot on-hand for the modal's named-lot-card header.
                    // Always sourced from the variant-aggregate lot's
                    // currentOnHand — the live on-hand value the server
                    // computes on every GET. Per-floor on-hand isn't tracked
                    // in the system, so floor-scoped mode shows the same
                    // variant-level number; the modal-side label switches
                    // to "Total variant on hand" to make the cross-floor
                    // nature explicit. Undefined when null so the modal
                    // hides the on-hand line if the value is missing.
                    const onHand: number | undefined =
                        l.currentOnHand != null ? l.currentOnHand : undefined;
                    // isSavedLot drives the modal's view-branching: true =
                    // render the read-only named-lot-card chrome, false =
                    // render the editable add-lot view. Gate on the
                    // client-side _pending flag set by applyLotAllocations.
                    // After count Save the server reload replaces item.lots
                    // entirely, drops the flag, and the lot flips to saved.
                    // Don't gate on lot.startOnHand here — per the C# model,
                    // StartOnHand stays null forever for lots added during a
                    // count, so it can't distinguish saved from applied.
                    const isSavedLot: boolean = !l._pending;
                    // WI 121230: in a conflict count, the conflict-start
                    // SP copies original-count lot rows with their prior
                    // ActualCount and computes IsCounted = (ActualCount IS
                    // NOT NULL); newly-detected lots (auto-pulled because
                    // their on-hand drifted post-count-creation) come in
                    // with ActualCount=NULL and IsCounted=0. So
                    // l.isCounted is the right signal for "was this lot
                    // counted in the original count?". Outside of conflict
                    // counts the modal ignores this flag, so passing it
                    // through unconditionally is safe.
                    const isCountedInOriginal: boolean = !!l.isCounted;
                    // Project count fields per the active scope: per-floor
                    // when a floor filter is active (defaulting to 0 for
                    // lots surfaced from the variant aggregate that aren't
                    // yet on this floor), variant-aggregate otherwise.
                    const perFloorLot = activeFloorId ? perFloorLotsById[l.variantLot_TId] : null;
                    const ac = activeFloorId
                        ? (perFloorLot && perFloorLot.actualCount != null ? perFloorLot.actualCount : 0)
                        : (l.actualCount != null ? l.actualCount : 0);
                    const acu = activeFloorId
                        ? (perFloorLot && perFloorLot.actualCountUnits != null ? perFloorLot.actualCountUnits : 0)
                        : (l.actualCountUnits != null ? l.actualCountUnits : 0);
                    if (!isEC) {
                        return {
                            variantLot_TId: l.variantLot_TId,
                            lotNumber: l.lotNumber,
                            expirationDate: l.expirationDate,
                            onHand,
                            isSavedLot,
                            isCountedInOriginal,
                            wholeQuantity: ac,
                            floorLocationId: activeFloorId,
                        };
                    }
                    return {
                        variantLot_TId: l.variantLot_TId,
                        lotNumber: l.lotNumber,
                        expirationDate: l.expirationDate,
                        onHand,
                        isSavedLot,
                        isCountedInOriginal,
                        wholeRows: [ac],
                        partialRows: [acu],
                        floorLocationId: activeFloorId,
                    };
                });
        }

        private buildLotModalInput(item: any): Meevo.Plugins.InventoryCount.IInventoryCountLotModalInput {
            return {
                context: 'inventory-count',
                variantId: item.variantId,
                productInventoryTypeEnum: item.productInventoryType,
                productDisplayName: item.productName || '',
                variantDisplayName: item.displayName || '',
                sku: item.sku,
                barCode: item.barCode || '',
                inventoryTypeDisplay: this.$translate.instant('ENUM_LABEL_' + item.productInventoryType),
                trackExpirationDate: !!item.trackExpirationDate,
                onHand: item.onHand,
                eachContains: this.isProductUsageEnabled(item),
                unitOfMeasureQuantity: item.unitOfMeasureQuantity,
                // Resolve to the product's specific UoM (e.g. "fl oz", "mL")
                // when the variant has one configured. The numeric enum maps
                // to a translation key of the form ENUM_LABEL_<value> in
                // en-US.json (matches the convention used in
                // product.usage.section.ts). Falls back to the generic
                // "Units" label only when no UoM is set on the product.
                unitOfMeasureLabel: this.$translate.instant(
                    item.productUnitOfMeasureEnum
                        ? 'ENUM_LABEL_' + item.productUnitOfMeasureEnum
                        : 'LABEL_UNITS'
                ),
                // WI 121230: parent count is a conflict count → modal renders ⚠
                // on uncounted lots. The existing flag `this.isConflict` is set
                // when the inventoryCount.displayName begins with "CONFLICT"
                // (see lines ~1503 and ~1941).
                isConflictCount: !!this.isConflict,
                // WI 117621: per-floor lot tracking. When the count's floor
                // filter is active (productSearchCriteria.floorLocationId set
                // and not Guid.empty) the modal is scoped to that floor's
                // per-floor lot counts only. Pass null when no floor filter
                // is active (All Locations) — the modal echoes that null back
                // on emit, and applyLotAllocations keeps the existing
                // variant-aggregate write path.
                floorLocationId: (this.productSearchCriteria
                                  && this.productSearchCriteria.floorLocationId
                                  && this.productSearchCriteria.floorLocationId != Guid.empty)
                    ? this.productSearchCriteria.floorLocationId
                    : null,
            };
        }

        private applyLotAllocations(
            item: any,
            allocations: Meevo.Plugins.InventoryCount.IInventoryCountAllocation[],
        ): void {
            const isEC = this.isProductUsageEnabled(item);
            // WI 117621: floor scope is derived from the canonical source
            // (productSearchCriteria.floorLocationId — same as buildLotModalInput
            // uses to pass it into the modal). Reading it off the first allocation
            // is unsafe: when the user clears the last lot in floor-scoped mode,
            // allocations arrives empty and the per-allocation read collapses to
            // null, which would route to applyLotAllocationsForVariant and wipe
            // every other floor's per-floor lot rows. Per-allocation floorLocationId
            // is informational; the count's floor scope is what governs the write
            // path.
            const allocs = allocations || [];
            const activeFloorId: string | null = (this.productSearchCriteria
                                                  && this.productSearchCriteria.floorLocationId
                                                  && this.productSearchCriteria.floorLocationId != Guid.empty)
                ? this.productSearchCriteria.floorLocationId
                : null;

            if (activeFloorId) {
                this.applyLotAllocationsForFloor(item, allocs, activeFloorId);
            } else {
                this.applyLotAllocationsForVariant(item, allocs);
            }

            const allLots = item.lots || [];
            item.actualCount = allLots.reduce((s: number, l: any) => s + ((l && l.actualCount) || 0), 0);
            const unitsTot = allLots.reduce((s: number, l: any) => s + ((l && l.actualCountUnits) || 0), 0);
            item.actualCountUnits = unitsTot || null;
            item.totalActualCountDisplay = this.getTotalActualCount(item);

            item.lotCountDisplay = this.computeLotCountDisplay(item);
            // Mark dirty so the existing save path treats this row as modified.
            item.isDirty = true;
            item.isCounted = true;
            // Per WI 121105 AC #5: Gain/Loss is computed across lots.
            this.recomputeGainLossForLotItem(item);
            // Persist via the existing autosave flow (mirrors onCountChanged).
            this.handleAutoSave(item);
        }

        /**
         * WI 130400 (E1): materialize a scan-driven lot-tracked variant into
         * inventoryCount.lineItems BEFORE applying its lots. Persistence and
         * autosave-cleanup key off lineItems membership, so the line must be a
         * member before applyLotAllocations runs (which autosaves per line).
         *
         * Re-scan of a variant already in the count reuses the SAME reference so
         * the lot apply mutates the live line item; a first scan pushes the
         * scanned entry with actualCount=0 (count comes from the lots the user
         * assigns in the modal, not the scanned aggregate) and isCounted=false
         * (applyLotAllocations sets it true once lots are applied).
         */
        applyScannedLotAllocations(lotEntry: any, allocations: any, surfacedLots?: any[]): void {
            var existing = this.inventoryCount.lineItems.filter(function (li) {
                return li.variantId == lotEntry.variantId && li.productInventoryType == lotEntry.productInventoryType;
            })[0];
            var item;
            if (existing != null) {
                item = existing;                          // re-scan: same reference
            } else {
                item = lotEntry;
                item.actualCount = 0;                     // count comes from lots, not aggregate
                item.isCounted = false;
                this.inventoryCount.lineItems.push(item);
            }
            this.applyLotAllocations(item, allocations);  // sets item.lots, isCounted, gain/loss, per-line autosave

            // Re-add any of the variant's surfaced lots the modal didn't touch, at
            // ActualCount=0. applyLotAllocations replaces item.lots wholesale with
            // only the modal's allocations; the SP requires EVERY pre-existing
            // DetailLot row for the variant to be present in the payload (N11), so
            // a 0-count lot the user didn't assign must still be sent. Skip lots
            // already present (the modal's allocations win for those).
            if (!item.lots) item.lots = [];
            var presentIds = item.lots.map(function (l) { return l && l.variantLot_TId; });
            (surfacedLots || []).forEach(function (sl) {
                if (sl && sl.variantLot_TId && presentIds.indexOf(sl.variantLot_TId) < 0) {
                    item.lots.push({
                        variantLot_TId: sl.variantLot_TId,
                        lotNumber: sl.lotNumber,
                        expirationDate: sl.expirationDate,
                        _pending: sl._pending,
                        startOnHand: sl.startOnHand != null ? sl.startOnHand : (sl.currentOnHand != null ? sl.currentOnHand : null),
                        endOnHand: sl.endOnHand != null ? sl.endOnHand : null,
                        currentOnHand: sl.currentOnHand != null ? sl.currentOnHand : 0,
                        actualCount: 0,
                        actualCountUnits: null,
                        // Match the variant Detail's counted state. The SP rejects
                        // (line 230) an uncounted DetailLot row under a counted
                        // Detail; a re-added 0-count lot under a counted variant is
                        // "counted, found 0".
                        isCounted: !!item.isCounted
                    });
                }
            });

            // Sync the line's aggregate count to the assigned lot totals.
            // applyLotAllocations writes item.lots but NOT item.actualCount, and a
            // scanned variant is materialized at actualCount=0 — so without this the
            // line persists with aggregate 0 and the count reverts to 0 on reload
            // (the server keys lot persistence off ActualCount). Mirrors how
            // incrementCount sets actualCount for non-lot scans. item.lots is the
            // cross-floor variant aggregate in both the variant and per-floor write
            // paths (applyLotAllocationsForFloor rebuilds it as the all-floor sum),
            // so summing it here yields the correct variant-wide aggregate.
            var lots = item.lots || [];
            item.actualCount = lots.reduce(function (s, l) { return s + ((l && l.actualCount) || 0); }, 0);
            var unitsSum = lots.reduce(function (s, l) { return s + ((l && l.actualCountUnits) || 0); }, 0);
            item.actualCountUnits = unitsSum || null;
        }

        /**
         * WI 130400 (E3): guard helper. When a scanned variant is lot-tracked
         * (and not an unresolved Retail/ShopSupply variant whose type is still
         * being chosen), divert it to the Assign Scanned Lots batch modal
         * instead of letting the aggregate-count write path run. Returns true
         * when diverted so callers can short-circuit.
         */
        divertIfLotTracked(v: any): boolean {
            if (v && v.trackLots && v.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                // Record the scanned variant as the current product, mirroring the
                // non-lot path (processVariant -> updateProductAndUpdateCount sets
                // this.product). Without this, a re-scan of the same lot-tracked R/S
                // variant trips the "new product scanned" reset in barcodeSearch
                // (productVariant.variantId !== this.product.variantId -> currentInventoryType
                // = null), which re-shows the per-line inventory-type picker every
                // scan. Setting it keeps the resolved type sticky across re-scans
                // exactly like a non-lot variant (WI 130400).
                this.product = v;
                // Flip the count type to this variant's type, mirroring the non-lot
                // handleBarcodeMatch path; otherwise a Shop Supply lot scanned into a
                // Retail count saves as an ineligible line and the server drops it
                // (WI 130400). Idempotent when the type is already resolved.
                this.resolveScannedInventoryType(v);
                this.openScannedLotModal([v], false);
                return true;
            }
            return false;
        }

        /**
         * WI 130400 (E2b): open the Assign Scanned Lots batch modal for one or
         * more scanned lot-tracked variants. Scanned variants arrive with empty
         * or stale item.lots, so hydrate every entry's lots from the
         * variant-level on-hand source (/Inventory/VariantLot/OnHand/ByVariant —
         * the same endpoint openLotModal uses) in a single call before reading
         * totals / building existing allocations. The endpoint accepts multiple
         * variants and tags each returned lot row with variantId (the base
         * VariantLot.VariantId column), so rows are grouped back to their entry
         * by variantId.
         *
         * Re-scan of a variant already in the count hydrates/projects against the
         * live line item (same reference applyScannedLotAllocations will reuse);
         * a first scan hydrates the scanned entry itself. The per-variant
         * scannedTarget is the current lot total plus this scan's importCount
         * (additive — the modal enforces assigned === target).
         */
        openScannedLotModal(lotEntries: any[], hadNonLot: boolean): void {
            if (!this.lotBridge) return;
            // Re-entrancy guard (WI 130400): don't mount a second lot modal while one
            // is already open/pending (Camera/File keep the scanner live behind it).
            if (this.lotModalPending) return;
            this.lotModalPending = true;
            var self = this;
            // Snapshot the active floor for the existing-allocations projection below.
            // applyLotAllocations (on Apply) reads productSearchCriteria.floorLocationId live to
            // pick the per-floor vs variant write path; that's safe because the Assign Scanned Lots
            // modal is a blocking overlay, so the floor filter cannot change between open and Apply.
            var floorSnapshot = (this.productSearchCriteria && this.productSearchCriteria.floorLocationId
                                 && this.productSearchCriteria.floorLocationId != Guid.empty)
                ? this.productSearchCriteria.floorLocationId : null;
            var targets = lotEntries.map(function (e) {
                var existing = self.inventoryCount.lineItems.filter(function (li) {
                    return li.variantId == e.variantId && li.productInventoryType == e.productInventoryType;
                })[0];
                return { entry: e, item: existing != null ? existing : e };
            });
            var req = { variants: targets.map(function (t) {
                return { variantId: t.item.variantId, productInventoryType: t.item.productInventoryType };
            }) };
            var lotLoadFailed = false;
            this.busyService.start();
            this.dataService.customMethodData(this.appSettings.API_ROOT + '/Inventory/VariantLot/OnHand/ByVariant', 'POST', req, { skipInterceptor: true })
                .then(function (resp) {
                    var byVariant = (resp && resp.data) || [];
                    targets.forEach(function (t) {
                        // Match on BOTH variantId AND productInventoryType: a RetailOrShopSupply
                        // lot-tracked product is split into two targets sharing the same variantId
                        // (different types), and Retail/Shop are separate stock. Filtering on
                        // variantId alone would merge both types' lot rows into each section.
                        var rows = byVariant.filter(function (r) {
                            return r.variantId == t.item.variantId && r.productInventoryType == t.item.productInventoryType;
                        });
                        self.mergeVariantLotOnHand(t.item, rows);
                    });
                })
                .catch(function () {
                    // Non-fatal but consequential: the OnHand lookup failed, so the modal will
                    // open with whatever lot rows item.lots already had (possibly stale/empty).
                    // Flag it so the finally below warns with a BLOCKING alert before the modal
                    // opens — a silently-incomplete existing-lot list can corrupt the assignment.
                    // (A toast was too easy to miss against the modal's gray scrim.)
                    lotLoadFailed = true;
                })
                .finally(function () {
                    self.busyService.stop();
                    var entries = targets.map(function (t) {
                        var input = self.buildLotModalInput(t.item);
                        // WI 130400: scanned target = the existing lot total plus this
                        // scan's whole-unit count. Use the COMPOSITE display total
                        // (computeLotCountDisplay: whole + partial fraction for
                        // Each-Contains, whole integer otherwise). A scan is whole units,
                        // but the user may distribute the scanned count across whole AND
                        // partial amounts for a partial-usage product, so the validation
                        // total (computeGrandTotal in the WC) is composite and the target
                        // must be composite too for `assigned === target` to be reachable.
                        var existingComposite = self.computeLotCountDisplay(t.item);
                        input.scannedTarget = existingComposite + (t.entry.importCount || 0);  // additive (composite + scanned wholes)
                        // false: seed ONLY the lots counted in this count, not every
                        // lot with on-hand stock (WI 130400 — "show only assigned lots").
                        var existingAllocs = self.buildExistingAllocations(t.item, floorSnapshot, false);
                        return {
                            lineItem: input,
                            existingAllocations: existingAllocs,
                            _entry: t.entry,
                            // Pre-existing DetailLot rows for this variant — lots counted in
                            // THIS count (isCounted, or a non-zero actual count). The SP
                            // (usp_InventoryCountDetailNoFloorSave) rejects (N11) if any
                            // pre-existing DetailLot row is absent from the payload, so on Apply
                            // we re-add any of these the user removed in the modal (at
                            // ActualCount=0 — the SP's "remove" signal). We deliberately EXCLUDE
                            // lots the on-hand merge surfaced but that were never counted in this
                            // count: persisting those would create spurious DetailLot rows and
                            // resurrect lots that don't belong to the count (the "showing all
                            // lots" bug). Filtered post-merge to the counted set.
                            _surfacedLots: angular.copy((t.item.lots || []).filter(function (l) {
                                return l && (!!l.isCounted || (l.actualCount || 0) !== 0 || (l.actualCountUnits || 0) !== 0);
                            }))
                        };
                    });
                    var openModal = function () {
                    self.lotBridge.openBatch(
                        entries.map(function (x) { return { lineItem: x.lineItem, existingAllocations: x.existingAllocations }; }),
                        function (results) {
                            self.lotModalPending = false;  // modal applied — allow the next scan to open one
                            for (var i = 0; i < results.length; i++) {
                                var match = entries.filter(function (x) {
                                    return x.lineItem.variantId == results[i].variantId
                                        && x.lineItem.productInventoryTypeEnum == results[i].productInventoryType;
                                })[0];
                                if (match != null) { self.applyScannedLotAllocations(match._entry, results[i].allocations, match._surfacedLots); }
                            }
                            // Persist via the full count save, exactly like the non-lot
                            // scan path (processMatches calls saveInventoryCount after
                            // processVariant). This is what makes scanned lot assignments
                            // stick WITHOUT the user hitting Save on the count — matching
                            // non-lot behavior. saveInventoryCount clears the pending
                            // per-line autosave timers first, so there is no double write.
                            //
                            // saveInventoryCount also calls closeCustomModal() (modalService.hide),
                            // which closes the Camera/File upload modal. In those modes the upload
                            // modal must stay open — and keep its live state (resolved inventory
                            // type, etc.) — so the user can keep uploading without re-picking the
                            // type each time. Pass keepScannerOpen so the same modal is left in
                            // place rather than hidden and reopened fresh. Device mode closes as
                            // before (it opens the lot modal AFTER the scanner is already gone).
                            var keepScannerOpen = self.barcodeScanMode == BarcodeScanModes.File
                                || self.barcodeScanMode == BarcodeScanModes.Camera;
                            self.saveInventoryCount(true, self.scannerOpened == 'mobile', undefined, keepScannerOpen);
                            self.successSound.play();
                        },
                        function () { self.lotModalPending = false; /* cancel: nothing applied */ },
                        self.isHideOnHand,
                        hadNonLot);
                    };
                    // On a failed existing-lot load, warn (blocking) FIRST, then open the modal
                    // when the user acknowledges — one dialog at a time, so the alert can't render
                    // behind the about-to-open modal's scrim (a toast there was too easy to miss).
                    // Open on either OK or dismiss: the degraded modal is still usable. Mirrors the
                    // bridge's own showLoadFailedAlert (modalService.alert) for lot-modal failures.
                    if (lotLoadFailed) {
                        self.modalService.alert(self.$translate.instant('LABEL_INVENTORY_COUNT_LOT_LOAD_FAILED'))
                            .then(openModal, openModal);
                    } else {
                        openModal();
                    }
                });
        }

        /**
         * WI 117621: variant-aggregate write path (no floor filter active).
         * Pre-117621 behavior, factored out so the per-floor branch can sit
         * cleanly alongside it. Replaces item.lots wholesale from the modal's
         * emitted allocations.
         */
        private applyLotAllocationsForVariant(
            item: any,
            allocations: Meevo.Plugins.InventoryCount.IInventoryCountAllocation[],
        ): void {
            const isEC = this.isProductUsageEnabled(item);
            // Capture the pre-Apply lots so we can preserve each lot's
            // startOnHand by variantLot_TId. The modal only edits counts —
            // it doesn't change a lot's prior on-hand — and the gain/loss
            // calculation reads lot.startOnHand. Without this, every Apply
            // would null it out and recomputeGainLossForLotItem would
            // over-report gain on existing lots.
            const priorLots = item.lots || [];
            // Per-lot rollup: collapse Each Contains row breakdowns into
            // aggregate totals. ActualCount = SUM of whole rows;
            // ActualCountUnits = SUM of partial rows (in usage units, matching
            // the variant-level partial-usage convention). Per-row breakdown
            // is NOT persisted — when the modal reopens, it regenerates a
            // single whole row + single partial row from these totals.
            item.lots = (allocations || []).map(a => {
                const priorLot = priorLots.find(l => l && l.variantLot_TId === a.variantLot_TId);
                // _pending marks lots whose state lives only in client memory
                // (Applied from the modal but not yet round-tripped through a
                // count Save). The next server reload overwrites item.lots
                // wholesale and drops the flag, so anything still carrying
                // _pending is "applied but unsaved." The bridge gates the
                // modal's named-lot-card vs. add-lot view on this. Newly-
                // added lots start true; re-applied lots that were already
                // pending stay pending; lots that were server-saved before
                // (priorLot exists without _pending) remain not-pending.
                const _pending: boolean = !priorLot || priorLot._pending === true;
                return {
                    variantLot_TId: a.variantLot_TId,
                    lotNumber: a.lotNumber,
                    expirationDate: a.expirationDate,
                    _pending,
                    // New lots (no prior match) keep startOnHand=null, which
                    // recomputeGainLossForLotItem treats as 0 — i.e. "lot
                    // didn't exist before, anything counted is gain". That
                    // matches AC #5's intent.
                    startOnHand: priorLot ? priorLot.startOnHand : null,
                    endOnHand: priorLot ? priorLot.endOnHand : null,
                    // Preserve currentOnHand from priorLot so the modal's
                    // named-lot-card on-hand display stays populated between
                    // Apply and the next GET refresh. The server will
                    // recompute this on every GET (per the C# model: "Live
                    // on-hand at GET time; computed by the GET sproc, not
                    // stored"), so this is purely an in-memory continuity
                    // fix. New lots default to 0 — they didn't have a prior
                    // value to preserve.
                    currentOnHand: priorLot && priorLot.currentOnHand != null ? priorLot.currentOnHand : 0,
                    actualCount: isEC
                        ? ((a.wholeRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                        : (a.wholeQuantity || 0),
                    actualCountUnits: isEC
                        ? ((a.partialRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                        : null,
                    isCounted: true,
                };
            });
        }

        /**
         * WI 117621: per-floor write path (floor filter active in the count).
         *
         * Writes the modal's emitted lot counts into the matching
         * productVariantsPerFloorLocation[i].lots collection for the active
         * floor (creating one if missing), then rebuilds the variant-aggregate
         * item.lots as the SUM across all floors so the existing C# repository
         * write path (which reads BOTH the variant-aggregate and per-floor
         * collections) sees a consistent parent-child shape and the SP's
         * parent-child sum validation passes.
         *
         * Variant-level metadata (lotNumber, expirationDate, on-hand fields)
         * is identical per lot regardless of floor — we copy it from any
         * floor's entry into the rebuilt aggregate, preferring a match on
         * variantLot_TId from the prior aggregate so previously-server-saved
         * on-hand snapshots survive the rebuild.
         */
        private applyLotAllocationsForFloor(
            item: any,
            allocations: Meevo.Plugins.InventoryCount.IInventoryCountAllocation[],
            floorLocationId: string,
        ): void {
            const isEC = this.isProductUsageEnabled(item);

            // 1. Locate (or create) the per-floor entry the modal was scoped to.
            if (!item.productVariantsPerFloorLocation) {
                item.productVariantsPerFloorLocation = [];
            }
            const perFloorList: any[] = item.productVariantsPerFloorLocation;
            let perFloorEntry = perFloorList.find((fl: any) => fl && fl.floorLocationId === floorLocationId);
            if (!perFloorEntry) {
                perFloorEntry = {
                    floorLocationId: floorLocationId,
                    variant_TId: item.variantId,
                    perFloorLocationActualCount: 0,
                    perFloorLocationActualCountUnits: 0,
                    lots: [],
                };
                perFloorList.push(perFloorEntry);
            }

            // 2. Replace this floor's per-floor lot rows from the modal output.
            // Per-floor lots intentionally don't carry on-hand — per-floor
            // on-hand isn't tracked in the system — so we only write the
            // identity + count fields the C# model has on its per-floor Lots
            // result set.
            //
            // Capture the lot ids that were already on this floor pre-Apply.
            // The modal now surfaces all variant-aggregate lots (including
            // ones with on-hand > 0 that aren't yet assigned to this floor),
            // so an Apply emits allocations for those too. Without this gate
            // a click-through Apply would write a 0-count per-floor entry
            // for every surfaced lot — creating phantom Floor_Lot rows on
            // a floor the user never actually counted them on.
            //
            // Save when count > 0 (active count on this floor) OR when the
            // lot was already on this floor pre-Apply (preserves the
            // explicit-0 "remove" action — sending count=0 for an existing
            // FloorLot row is how the user clears a lot from a floor; F11
            // requires it to stay in the TVP). Drop when count == 0 AND
            // not previously on this floor.
            const previouslyOnFloorIds: { [id: string]: true } = {};
            const priorPerFloorLots = (perFloorEntry.lots as any[]) || [];
            for (let i = 0; i < priorPerFloorLots.length; i++) {
                const pfl = priorPerFloorLots[i];
                if (pfl && pfl.variantLot_TId) {
                    previouslyOnFloorIds[pfl.variantLot_TId] = true;
                }
            }

            perFloorEntry.lots = (allocations || []).filter(a => {
                const wholeCount = isEC
                    ? ((a.wholeRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                    : (a.wholeQuantity || 0);
                const partialCount = isEC
                    ? ((a.partialRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                    : 0;
                const hasCount = (wholeCount || 0) > 0 || (partialCount || 0) > 0;
                const wasOnFloor = !!previouslyOnFloorIds[a.variantLot_TId];
                return hasCount || wasOnFloor;
            }).map(a => ({
                variantLot_TId: a.variantLot_TId,
                lotNumber: a.lotNumber,
                expirationDate: a.expirationDate,
                actualCount: isEC
                    ? ((a.wholeRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                    : (a.wholeQuantity || 0),
                actualCountUnits: isEC
                    ? ((a.partialRows || []).reduce((s: number, n: number) => s + (n || 0), 0))
                    : 0,
            }));

            // 3. Recompute the per-floor entry's aggregate count fields from
            // its new lot rows. The C# repository's existing per-floor write
            // path reads these (perFloorLocationActualCount /
            // perFloorLocationActualCountUnits) — keeping them in sync with
            // sum-of-lots avoids a stale parent on save.
            let perFloorWhole = 0;
            let perFloorPartial = 0;
            for (const fl of perFloorEntry.lots) {
                perFloorWhole += (fl.actualCount || 0);
                perFloorPartial += (fl.actualCountUnits || 0);
            }
            perFloorEntry.perFloorLocationActualCount = perFloorWhole;
            perFloorEntry.perFloorLocationActualCountUnits = isEC ? perFloorPartial : 0;

            // 4. Rebuild the variant-aggregate item.lots as SUM across ALL
            // floors so the existing C# write path (which reads variant-
            // aggregate item.lots in addition to per-floor lots) stays
            // consistent. Group by variantLot_TId; sum actualCount and
            // actualCountUnits; preserve variant-level metadata (lotNumber,
            // expirationDate, startOnHand, currentOnHand) by matching on
            // variantLot_TId against the pre-Apply variant-aggregate so prior
            // server-saved on-hand snapshots survive — that keeps gain/loss
            // accurate.
            const priorVariantLots: any[] = item.lots || [];
            // Plain-object dictionary keyed by variantLot_TId. Avoids ES5
            // iterator-spread (`[...map.values()]`), which the host shell's
            // TS 2.x toolchain rejects on Map<>.values(). The order is the
            // insertion order of first-seen lot ids across the floors loop —
            // sufficient for save-time consumption (the modal re-sorts by
            // expiration on next open).
            const aggMap: { [id: string]: any } = {};
            const aggKeys: string[] = [];
            for (const fl of perFloorList) {
                if (!fl || !fl.lots) continue;
                for (const flLot of fl.lots) {
                    if (!flLot) continue;
                    const id: string = flLot.variantLot_TId;
                    let agg = aggMap[id];
                    if (!agg) {
                        const priorLot = priorVariantLots.find(l => l && l.variantLot_TId === id);
                        agg = {
                            variantLot_TId: id,
                            lotNumber: flLot.lotNumber,
                            expirationDate: flLot.expirationDate,
                            // _pending: anything not previously server-saved
                            // (no priorLot, or priorLot._pending) stays
                            // pending. The bridge keeps the named-lot-card
                            // editable until count Save round-trips.
                            _pending: !priorLot || priorLot._pending === true,
                            startOnHand: priorLot ? priorLot.startOnHand : null,
                            endOnHand: priorLot ? priorLot.endOnHand : null,
                            currentOnHand: priorLot && priorLot.currentOnHand != null ? priorLot.currentOnHand : 0,
                            actualCount: 0,
                            actualCountUnits: isEC ? 0 : null,
                            isCounted: true,
                        };
                        aggMap[id] = agg;
                        aggKeys.push(id);
                    }
                    agg.actualCount += (flLot.actualCount || 0);
                    if (isEC) {
                        agg.actualCountUnits = (agg.actualCountUnits || 0) + (flLot.actualCountUnits || 0);
                    }
                }
            }
            // Preserve any variant-aggregate lots that don't appear in any
            // per-floor entry. The modal now surfaces these (so the user
            // can assign them to a floor), and an Apply with no count
            // entered drops them from the per-floor save (handled in step 2
            // above). They still belong on item.lots — without this pass
            // they'd silently disappear from the variant-aggregate after
            // every floor-scoped Apply, and a subsequent open in a different
            // scope (or no filter) wouldn't see them. Use count=0 so the
            // sum stays correct (these lots contribute nothing on this
            // save), and carry isCounted from the prior row so commit-time
            // coherence (parent.IsCounted = All(lot.IsCounted)) preserves
            // whatever the prior state was.
            for (let i = 0; i < priorVariantLots.length; i++) {
                const priorLot = priorVariantLots[i];
                if (!priorLot || !priorLot.variantLot_TId) continue;
                if (aggMap[priorLot.variantLot_TId]) continue;
                aggMap[priorLot.variantLot_TId] = {
                    variantLot_TId: priorLot.variantLot_TId,
                    lotNumber: priorLot.lotNumber,
                    expirationDate: priorLot.expirationDate,
                    _pending: priorLot._pending === true,
                    startOnHand: priorLot.startOnHand,
                    endOnHand: priorLot.endOnHand,
                    currentOnHand: priorLot.currentOnHand != null ? priorLot.currentOnHand : 0,
                    actualCount: 0,
                    actualCountUnits: isEC ? 0 : null,
                    isCounted: !!priorLot.isCounted,
                };
                aggKeys.push(priorLot.variantLot_TId);
            }
            item.lots = aggKeys.map(k => aggMap[k]);

            // 5. item.actualCount = SUM of per-floor actualCount across all
            // floors. The variant-aggregate save path uses this as the
            // canonical "counted" value for the row, so it has to mirror the
            // sum of the per-floor children.
            let totalWhole = 0;
            let totalPartial = 0;
            for (const fl of perFloorList) {
                totalWhole += (fl.perFloorLocationActualCount || 0);
                totalPartial += (fl.perFloorLocationActualCountUnits || 0);
            }
            item.actualCount = totalWhole;
            if (isEC) {
                item.actualCountUnits = totalPartial;
            }
        }

        /**
         * Per WI 121105 AC #5: named lot discrepancies only — no unassigned
         * write-off. (counted - startOnHand) × variantWholesale, summed across
         * lots. Wholesale per-lot is the variant's wholesale (lots don't have
         * separate cost per [D09]).
         *
         * Correctness depends on lot.startOnHand being preserved through
         * modal Apply — see applyLotAllocations, which now keeps the prior
         * startOnHand from the matched lot rather than nulling it. Without
         * that, every existing lot would read prior on-hand as 0 here and
         * over-report the gain.
         */
        private recomputeGainLossForLotItem(item: any): void {
            if (!item || !item.lots) {
                item.gainLoss = 0;
                return;
            }
            const isEC = this.isProductUsageEnabled(item);
            const wholeSale = item.wholeSale || 0;
            let gainLoss = 0;
            for (const lot of item.lots) {
                if (!lot) continue;
                const counted = isEC
                    ? (lot.actualCount || 0) + ((lot.actualCountUnits || 0) / (item.unitOfMeasureQuantity || 1))
                    : (lot.actualCount || 0);
                const start = lot.startOnHand != null ? lot.startOnHand : 0;
                gainLoss += (counted - start) * wholeSale;
            }
            item.gainLoss = gainLoss;
        }

        gainLossDisplayValue(item) {
            if (!item) return '';
            if (!item.isCounted) {
                return 0;
            }
            if (item.gainLoss == null) {
                item.gainLoss = this.gainLossValue(item);
            }
            var gainLossStr = this.meevoCurrency(Math.abs(item.gainLoss || 0));
            return (item.gainLoss < 0) ? "(" + gainLossStr + ")" : gainLossStr;
        }

        isInConflict(item) {
            if (!item) return false;
            var startOnHand: number = (item.startOnHand == 0) ? 0 : (item.startOnHand || item.onHand);
            return (this.inventoryCount.id && startOnHand != item.onHand && !this.isHideOnHand && this.inventoryCount.state != 1688);
        }

        swipeLeft(prod) : void {
            console.log('swiped left', prod);
            prod.showTrash = true;
        }
        swipeRight(prod) : void {
            console.log('swiped right', prod);
            prod.showTrash = false;
        }

        startMobileCount() : void {
            this.edit();
            this.isAutoSaveEnabled = true;
            if (this.inSaveProcess) {
                this.$timeout(() => {
                    this.search();
                }, 1000)
                return;
            } else {
                this.search();
            }
        }

        startNewCount() : void {
            this.resetInventoryCount();
            this.setInventoryCountDefaults();
            this.createNewCount();            
        }

        isShopSupply(variant) : boolean {
            if (!variant) return false;
            return variant.productInventoryType == Meevo.Model.ProductInventoryTypeEnum.ShopSupply;
        }

        toggleAddExpanded() : void {
            this.addExpanded = !this.addExpanded;
            if (this.addExpanded) {
                $('#product-lookup-input input').bind('blur', () => {
                    setTimeout(() => {
                        this.controller.$scope.$apply();
                    }, 1);
                })
            }                
            setTimeout(() => {
                this.controller.$scope.$apply();
            }, 1);
            
        }

        productSelected() : void {
            this.controller.viewSwitch('count');
            if (this.productLookup) {
                this.productVariantFilter = "";

                let existingIndex = this.inventoryCount.lineItems.findIndex(x => x.variantId == this.productLookup.variantId
                                                                                && x.productInventoryType == this.productLookup.productInventoryType);
                let existing = existingIndex > -1 ? this.inventoryCount.lineItems[existingIndex] : null;

                if (existing && !existing.isDeleted && existing.isCounted) {
                    // Already actively counted — re-selecting it must be a no-op on its
                    // saved value. this.productLookup is a fresh typeahead-result object,
                    // not the existing line item — zeroing it and autosaving it (below)
                    // would silently overwrite the existing, already-persisted actualCount
                    // with 0 for that variant, even though the visible grid row is never
                    // touched.
                    this.highlightAddedItem(existing);
                    this.product = existing;
                    return;
                }

                if (existing && !existing.isDeleted) {
                    // Present but not yet counted — e.g. a filter Search populates
                    // lineItems with every match, most uncounted. Users expect selecting
                    // it from Add Product to mark it counted and save, same as a
                    // brand-new row. Mark and autosave THIS row rather than substituting
                    // productLookup — posting a different object under the same
                    // variant/type autosave key is what silently zeroed real counts.
                    existing.isCounted = true;
                    existing.isDirty = true;
                    this.highlightAddedItem(existing);
                    this.product = existing;
                    this.handleAutoSave(existing, true);
                    return;
                }

                // Not present at all, or present but soft-deleted (removeLineItem hard-
                // deletes server-side via Variant_Del but never splices the row out of
                // lineItems). Either way this is a fresh count for the variant: init from
                // productLookup and explicitly clear the breakdown collections, since a
                // soft-deleted row (or the count-scoped lookup query itself, if the delete's
                // own autosave hasn't committed yet) can still carry non-zero per-floor/
                // lot/modal data from before removal — leaving that alongside
                // actualCount=0 trips the save proc's parent/child sum-match validation.
                this.productLookup.isCounted = true;
                this.productLookup.isDirty = true;
                this.productLookup.actualCount = 0;
                this.productLookup.actualCountUnits = null;
                this.productLookup.totalActualCountDisplay = 0;
                this.productLookup.lots = [];
                this.productLookup.productVariantsPerFloorLocation = [];
                this.productLookup.inventoryCountLineItemModalList = [];
                let onHandValue = this.productLookup.startOnHand == null ? (this.productLookup.onHand || 0) : this.productLookup.startOnHand;
                this.productLookup.decimalPrecision = (this.isProductUsageEnabled(this.productLookup) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;

                if (existing) {
                    this.inventoryCount.lineItems[existingIndex] = this.productLookup;
                } else {
                    this.inventoryCount.lineItems.unshift(this.productLookup);
                }
                this.inventoryCount.decimalPrecision = this.inventoryCount.decimalPrecision || this.productLookup.decimalPrecision;
                this.highlightAddedItem(this.productLookup);
                this.product = this.productLookup;
                this.handleAutoSave(this.productLookup, true);
            }
        }
        
        productFilterChange() : void {
            if (!this.productVariantFilter) {
                this.searchExpanded = false;
            }
        }

        showMobileCameraIcon() : boolean {
            return this.isStateOpen() && !this.isReadonly()
        }

        showMobileSaveIcon() : boolean {
            return this.isStateOpen() && this.controller.mobileView !== 'action';
        }

        availableToSave() : boolean {
            return !!(this.inventoryCount.id) || !this.isInventoryCountDetailEmpty()
        }

        mobileBackButtonClicked() : void {
            if (this.controller.mobileView == 'action') {
                this.controller.viewSwitch('count');
                this.edit();
            } else {
                this.back();
            }
        }

        closeBarcodeScanner() : void {
            this.scannerOpened = null;
        }

        getMobileVirtualRepeatHeight() : string {
            let scrollTop     = $(window).scrollTop();
            let elementOffset = $('.count-detail-wrapper').offset().top
            let distance      = (elementOffset - scrollTop);
            let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            let footerHeight = $('#mobile-inventorycount-footer').height();
            return `${vh - (distance + footerHeight)}px`
        }

        attachMobileProductLookupHandler() {
            // otherwise dynamic height of mobile virtual repeater doesn't change until user interaction
            $('#mobile-count #product-lookup-input input').on('blur', () => {
                setTimeout(() => {
                    this.controller.$scope.$apply();    
                }, 1000);
            })
        }

        setPartialUsage(event, entry: LineItems) {
            event.stopPropagation();

            let modalOptions: Meevo.Components.Controls.PartialUsageModalOptions = {
                productId: entry.id,
                variantIdInitiator: entry.variantId,
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryCount,
                entry: entry,
                quantityWholeList: entry.inventoryCountLineItemModalList
                    && entry.inventoryCountLineItemModalList.length > 0
                    && entry.inventoryCountLineItemModalList.some(item => item.productUsageType == ProductUsageAmountTypeEnum.WholeProduct)
                    ? entry.inventoryCountLineItemModalList
                        .filter(item => item.productUsageType == ProductUsageAmountTypeEnum.WholeProduct)
                        .map((item, ndx, arr) => <Meevo.Model.QuantityValueType>{ quantity: item.quantity })
                    : [{ quantity: entry.actualCount || 0 }],
                quantityUnitsList: entry.inventoryCountLineItemModalList
                    && entry.inventoryCountLineItemModalList.length > 0
                    && entry.inventoryCountLineItemModalList.some(item => item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                    ? entry.inventoryCountLineItemModalList
                        .filter(item => item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                        .map((item, ndx, arr) => <Meevo.Model.QuantityValueType>{ quantity: item.quantity })
                    : [{ quantity: entry.actualCountUnits || 0 }],
                totalCompositeValue: null,
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/controls/productPartialUsage/partialUsage.template.html",
                controller: "meevo.components.controls.productPartialUsage.PartialUsageController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options)
                .then((applied) => {
                    if (applied) {
                        entry.isDirty = true;                        
                        entry.totalActualCountDisplay = modalOptions.totalCompositeValue;
                        entry.actualCount = modalOptions.totalWhole;
                        entry.actualCountUnits = modalOptions.totalUnits;
                        entry.floorLocationId = entry.floorLocationId ? entry.floorLocationId: this.inventoryCount.floorLocationId;
                        entry.inventoryCountLineItemModalList = [
                            ...modalOptions.quantityWholeList.map((item, index) => (
                                {
                                    sortOrder: index,
                                    productUsageType: ProductUsageAmountTypeEnum.WholeProduct,
                                    quantity: item.quantity,
                                    productInventoryType: entry.productInventoryType,
                                    floor_LId: entry.floorLocationId ? entry.floorLocationId : null
                                }
                            )),
                            ...modalOptions.quantityUnitsList.map((item, index) => (
                                {
                                    sortOrder: index,
                                    productUsageType: ProductUsageAmountTypeEnum.PartialAmount,
                                    quantity: item.quantity,
                                    productInventoryType: entry.productInventoryType,
                                    floor_LId: entry.floorLocationId ? entry.floorLocationId : null
                                }
                            )),
                        ];                      
                        entry.isCounted = true;  // #79091
                        if (entry.isCounted) {
                            entry.isDeleted = false;
                        }
                        entry.gainLoss = this.gainLossValue(entry);
                        this.product = entry;
                        this.checkIfCounted(entry);
                        this.handleAutoSave(entry);
                    }
                });
        }

        getTotalActualCount(item: LineItems): number {
            if (this.isProductUsageEnabled(item)) {
                let partial: number = item.actualCountUnits ? this.roundingService.divideNormalizedNumbers(item.actualCountUnits, item.unitOfMeasureQuantity, this.decimalPrecision) : 0;
                return this.roundingService.add(item.actualCount || 0, partial, this.decimalPrecision);
            }
            return item.actualCount || 0;
        }

        getUnitsDisplay(item: LineItems, onHandValue?: number): number { 
            if (onHandValue || onHandValue === 0) {
                return this.roundingService.multiply(onHandValue, item.unitOfMeasureQuantity);
            } else {
                let wholeUnits: number = this.roundingService.multiply(item.actualCount, item.unitOfMeasureQuantity);
                return this.roundingService.add(wholeUnits, item.actualCountUnits);
            }
        }

        isProductUsageEnabled(variant: LineItems): boolean {
            return this.tenantEnableProductUsageTracking && variant && variant.enableProductUsageTracking && variant.productUsageType == ProductUsageAmountTypeEnum.PartialAmount;
        }

        getDecimalPrecision(item: any): number {
            return (this.tenantEnableProductUsageTracking && item && item.enableProductUsageTracking && item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                ? this.decimalPrecision
                : null;
        }

        hasPartial(item: number): boolean {
            return !Number.isInteger(item);
        }

        scrollHeader(event) {
            $(".inventory-table.clone")[0].scrollLeft = $(".inventory-table-container.meevo-scrollbar")[0].scrollLeft;
        }
        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

    }
}
